/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as TermServiceRouteImport } from './routes/term-service'
import { Route as SuccessRouteImport } from './routes/success'
import { Route as SubscriptionRequiredRouteImport } from './routes/subscription-required'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PaymentFailedRouteImport } from './routes/payment-failed'
import { Route as PatientPolicyRouteImport } from './routes/patient-policy'
import { Route as NewPasswordRouteImport } from './routes/new-password'
import { Route as ManageSubscriptionRouteImport } from './routes/manage-subscription'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DeleteAccountSuccessRouteImport } from './routes/delete-account-success'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as AccountRouteImport } from './routes/account'
import { Route as SsoRouteRouteImport } from './routes/sso/route'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as CreateAccountRouteRouteImport } from './routes/create-account/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CreateAccountIndexRouteImport } from './routes/create-account/index'
import { Route as SubscriptionPlanRouteImport } from './routes/subscription/$plan'
import { Route as SsoSigninRouteImport } from './routes/sso/signin'
import { Route as SsoSelectProviderRouteImport } from './routes/sso/select-provider'
import { Route as CreateAccountVerifyMobileRouteImport } from './routes/create-account/verify-mobile'
import { Route as CreateAccountProfessionalProfileRouteImport } from './routes/create-account/professional-profile'
import { Route as CreateAccountProfessionalCredentialsRouteImport } from './routes/create-account/professional-credentials'
import { Route as CreateAccountCookieCredentialsRouteImport } from './routes/create-account/cookie-credentials'
import { Route as DashboardTeamsRouteRouteImport } from './routes/dashboard/teams/route'
import { Route as DashboardInboxRouteRouteImport } from './routes/dashboard/inbox/route'
import { Route as DashboardContactsRouteRouteImport } from './routes/dashboard/contacts/route'
import { Route as DashboardChatRouteRouteImport } from './routes/dashboard/chat/route'
import { Route as DashboardCaseRouteRouteImport } from './routes/dashboard/case/route'
import { Route as DashboardCameraRouteRouteImport } from './routes/dashboard/camera/route'
import { Route as DashboardCalendarRouteRouteImport } from './routes/dashboard/calendar/route'
import { Route as DashboardBulletinRouteRouteImport } from './routes/dashboard/bulletin/route'
import { Route as DashboardInboxIndexRouteImport } from './routes/dashboard/inbox/index'
import { Route as DashboardGalleryIndexRouteImport } from './routes/dashboard/gallery/index'
import { Route as DashboardContactsIndexRouteImport } from './routes/dashboard/contacts/index'
import { Route as DashboardCaseIndexRouteImport } from './routes/dashboard/case/index'
import { Route as DashboardCameraIndexRouteImport } from './routes/dashboard/camera/index'
import { Route as DashboardCalendarIndexRouteImport } from './routes/dashboard/calendar/index'
import { Route as DashboardBulletinIndexRouteImport } from './routes/dashboard/bulletin/index'
import { Route as DashboardAccountsIndexRouteImport } from './routes/dashboard/accounts/index'
import { Route as DashboardGalleryVideoRouteImport } from './routes/dashboard/gallery/video'
import { Route as DashboardGalleryExportsRouteImport } from './routes/dashboard/gallery/exports'
import { Route as DashboardGalleryCameraRouteImport } from './routes/dashboard/gallery/camera'
import { Route as DashboardContactsNoAccessRouteImport } from './routes/dashboard/contacts/no-access'
import { Route as DashboardCaseStatusRouteImport } from './routes/dashboard/case/$status'
import { Route as DashboardBulletinSettingRouteImport } from './routes/dashboard/bulletin/setting'
import { Route as DashboardTeamsCreateRouteRouteImport } from './routes/dashboard/teams/create/route'
import { Route as DashboardTeamsIdRouteRouteImport } from './routes/dashboard/teams/$id/route'
import { Route as DashboardInboxRemindersRouteRouteImport } from './routes/dashboard/inbox/reminders/route'
import { Route as DashboardInboxAlertsRouteRouteImport } from './routes/dashboard/inbox/alerts/route'
import { Route as DashboardGalleryViewRouteRouteImport } from './routes/dashboard/gallery/view/route'
import { Route as DashboardCaseViewRouteRouteImport } from './routes/dashboard/case/view/route'
import { Route as DashboardCaseReferralsRouteRouteImport } from './routes/dashboard/case/referrals/route'
import { Route as DashboardCaseRecordsRouteRouteImport } from './routes/dashboard/case/records/route'
import { Route as DashboardCaseProgressNotesRouteRouteImport } from './routes/dashboard/case/progress-notes/route'
import { Route as DashboardCalendarEventsRouteRouteImport } from './routes/dashboard/calendar/events/route'
import { Route as DashboardTeamsCreateIndexRouteImport } from './routes/dashboard/teams/create/index'
import { Route as DashboardTeamsIdIndexRouteImport } from './routes/dashboard/teams/$id/index'
import { Route as DashboardInboxRemindersIndexRouteImport } from './routes/dashboard/inbox/reminders/index'
import { Route as DashboardInboxAlertsIndexRouteImport } from './routes/dashboard/inbox/alerts/index'
import { Route as DashboardContactsDirectoryIndexRouteImport } from './routes/dashboard/contacts/directory/index'
import { Route as DashboardContactsContactIndexRouteImport } from './routes/dashboard/contacts/contact/index'
import { Route as DashboardChatSingleIndexRouteImport } from './routes/dashboard/chat/single/index'
import { Route as DashboardChatGroupIndexRouteImport } from './routes/dashboard/chat/group/index'
import { Route as DashboardCaseReferralsIndexRouteImport } from './routes/dashboard/case/referrals/index'
import { Route as DashboardCaseRecordsIndexRouteImport } from './routes/dashboard/case/records/index'
import { Route as DashboardCaseProgressNotesIndexRouteImport } from './routes/dashboard/case/progress-notes/index'
import { Route as DashboardCasePatientIndexRouteImport } from './routes/dashboard/case/patient/index'
import { Route as DashboardCaseCreateIndexRouteImport } from './routes/dashboard/case/create/index'
import { Route as DashboardTeamsCreateNameRouteImport } from './routes/dashboard/teams/create/name'
import { Route as DashboardInboxRemindersCreateRouteImport } from './routes/dashboard/inbox/reminders/create'
import { Route as DashboardInboxRemindersCompletedRouteImport } from './routes/dashboard/inbox/reminders/completed'
import { Route as DashboardInboxRemindersIdRouteImport } from './routes/dashboard/inbox/reminders/$id'
import { Route as DashboardGalleryViewIdRouteImport } from './routes/dashboard/gallery/view/$id'
import { Route as DashboardContactsMemberIdRouteImport } from './routes/dashboard/contacts/member.$id'
import { Route as DashboardChatSingleCreateRouteImport } from './routes/dashboard/chat/single/create'
import { Route as DashboardChatMessageIdRouteImport } from './routes/dashboard/chat/message/$id'
import { Route as DashboardChatGroupCreateRouteImport } from './routes/dashboard/chat/group/create'
import { Route as DashboardCaseReferralsTypeRouteImport } from './routes/dashboard/case/referrals/type'
import { Route as DashboardCaseReferralsSuccessRouteImport } from './routes/dashboard/case/referrals/success'
import { Route as DashboardCaseReferralsMessageRouteImport } from './routes/dashboard/case/referrals/message'
import { Route as DashboardCaseReferralsContactRouteImport } from './routes/dashboard/case/referrals/contact'
import { Route as DashboardCaseRecordsClosedRouteImport } from './routes/dashboard/case/records/closed'
import { Route as DashboardCaseProgressNotesClosedRouteImport } from './routes/dashboard/case/progress-notes/closed'
import { Route as DashboardCaseMessageIdRouteImport } from './routes/dashboard/case/message.$id'
import { Route as DashboardCalendarEventsCreateRouteImport } from './routes/dashboard/calendar/events/create'
import { Route as DashboardTeamsIdMembersRouteRouteImport } from './routes/dashboard/teams/$id/members/route'
import { Route as DashboardTeamsIdEditRouteRouteImport } from './routes/dashboard/teams/$id/edit/route'
import { Route as DashboardChatSingleHemiRouteRouteImport } from './routes/dashboard/chat/single/hemi/route'
import { Route as DashboardChatSingleIdRouteRouteImport } from './routes/dashboard/chat/single/$id/route'
import { Route as DashboardChatGroupIdRouteRouteImport } from './routes/dashboard/chat/group/$id/route'
import { Route as DashboardCaseViewIdRouteRouteImport } from './routes/dashboard/case/view/$id/route'
import { Route as DashboardCalendarEventsIdRouteRouteImport } from './routes/dashboard/calendar/events/$id/route'
import { Route as DashboardTeamsIdEditIndexRouteImport } from './routes/dashboard/teams/$id/edit/index'
import { Route as DashboardContactsDirectoryTeamsIndexRouteImport } from './routes/dashboard/contacts/directory/teams/index'
import { Route as DashboardContactsContactTeamsIndexRouteImport } from './routes/dashboard/contacts/contact/teams/index'
import { Route as DashboardChatSingleHemiIndexRouteImport } from './routes/dashboard/chat/single/hemi/index'
import { Route as DashboardChatGroupIdIndexRouteImport } from './routes/dashboard/chat/group/$id/index'
import { Route as DashboardCaseViewIdIndexRouteImport } from './routes/dashboard/case/view/$id/index'
import { Route as DashboardCaseCreateExistIndexRouteImport } from './routes/dashboard/case/create/exist/index'
import { Route as DashboardAccountsSettingsProfileIndexRouteImport } from './routes/dashboard/accounts/settings/profile/index'
import { Route as DashboardAccountsSettingsAccountIndexRouteImport } from './routes/dashboard/accounts/settings/account/index'
import { Route as DashboardTeamsIdMembersSearchRouteImport } from './routes/dashboard/teams/$id/members/search'
import { Route as DashboardTeamsIdEditMembersRouteImport } from './routes/dashboard/teams/$id/edit/members'
import { Route as DashboardChatSingleIdChannelNameRouteImport } from './routes/dashboard/chat/single/$id/$channelName'
import { Route as DashboardChatGroupIdMembersRouteImport } from './routes/dashboard/chat/group/$id/members'
import { Route as DashboardChatGroupIdEditRouteImport } from './routes/dashboard/chat/group/$id/edit'
import { Route as DashboardChatGroupIdDetailRouteImport } from './routes/dashboard/chat/group/$id/detail'
import { Route as DashboardChatGroupIdChannelNameRouteImport } from './routes/dashboard/chat/group/$id/$channelName'
import { Route as DashboardCaseViewIdSearchRouteImport } from './routes/dashboard/case/view/$id/search'
import { Route as DashboardCaseViewIdExportRouteImport } from './routes/dashboard/case/view/$id/export'
import { Route as DashboardCaseViewIdDetailRouteImport } from './routes/dashboard/case/view/$id/detail'
import { Route as DashboardCaseCreateExistRequestCompleteRouteImport } from './routes/dashboard/case/create/exist/request-complete'
import { Route as DashboardCalendarEventsIdEditRouteImport } from './routes/dashboard/calendar/events/$id/edit'
import { Route as DashboardAccountsSettingsProfileInformationRouteImport } from './routes/dashboard/accounts/settings/profile/information'
import { Route as DashboardAccountsSettingsProfileCredentialsRouteImport } from './routes/dashboard/accounts/settings/profile/credentials'
import { Route as DashboardAccountsSettingsAccountVerifyPhoneNumberRouteImport } from './routes/dashboard/accounts/settings/account/verify-phone-number'
import { Route as DashboardAccountsSettingsAccountNewPasswordRouteImport } from './routes/dashboard/accounts/settings/account/new-password'
import { Route as DashboardAccountsSettingsAccountDeleteAccountRouteImport } from './routes/dashboard/accounts/settings/account/delete-account'
import { Route as DashboardAccountsSettingsAccountChangePhoneNumberRouteImport } from './routes/dashboard/accounts/settings/account/change-phone-number'
import { Route as DashboardAccountsSettingsAccountChangePasswordRouteImport } from './routes/dashboard/accounts/settings/account/change-password'
import { Route as DashboardAccountsSettingsAccountChangeEmailRouteImport } from './routes/dashboard/accounts/settings/account/change-email'
import { Route as DashboardCaseViewIdMembersRouteRouteImport } from './routes/dashboard/case/view/$id/members/route'
import { Route as DashboardCaseViewIdLetterRouteRouteImport } from './routes/dashboard/case/view/$id/letter/route'
import { Route as DashboardCaseViewIdCaseInfoRouteRouteImport } from './routes/dashboard/case/view/$id/case-info/route'
import { Route as DashboardCaseViewIdPatientVisitsIndexRouteImport } from './routes/dashboard/case/view/$id/patient-visits/index'
import { Route as DashboardCaseViewIdMembersIndexRouteImport } from './routes/dashboard/case/view/$id/members/index'
import { Route as DashboardCaseViewIdMedicalNoteIndexRouteImport } from './routes/dashboard/case/view/$id/medical-note/index'
import { Route as DashboardCaseViewIdPatientVisitsCreateRouteImport } from './routes/dashboard/case/view/$id/patient-visits/create'
import { Route as DashboardCaseViewIdMembersExternalRouteImport } from './routes/dashboard/case/view/$id/members/external'
import { Route as DashboardCaseViewIdMedicalNoteCreateRouteImport } from './routes/dashboard/case/view/$id/medical-note/create'
import { Route as DashboardCaseCreateExistRequestCaseIdRouteImport } from './routes/dashboard/case/create/exist/request.$caseId'
import { Route as DashboardCaseCreateExistPatientPatientIcRouteImport } from './routes/dashboard/case/create/exist/patient.$patientIc'
import { Route as DashboardCaseViewIdLetterNewRouteRouteImport } from './routes/dashboard/case/view/$id/letter/new/route'
import { Route as DashboardCaseViewIdLetterLetterIdRouteRouteImport } from './routes/dashboard/case/view/$id/letter/$letterId/route'
import { Route as DashboardCaseViewIdCaseInfoTypeRouteRouteImport } from './routes/dashboard/case/view/$id/case-info/$type/route'
import { Route as DashboardCaseViewIdLetterNewIndexRouteImport } from './routes/dashboard/case/view/$id/letter/new/index'
import { Route as DashboardCaseViewIdLetterLetterIdIndexRouteImport } from './routes/dashboard/case/view/$id/letter/$letterId/index'
import { Route as DashboardCaseViewIdCaseInfoTypeIndexRouteImport } from './routes/dashboard/case/view/$id/case-info/$type/index'
import { Route as DashboardCaseViewIdLetterNewInfoRouteImport } from './routes/dashboard/case/view/$id/letter/new/info'
import { Route as DashboardCaseViewIdLetterLetterIdUpdateRouteImport } from './routes/dashboard/case/view/$id/letter/$letterId/update'
import { Route as DashboardCaseViewIdLetterLetterIdExportRouteImport } from './routes/dashboard/case/view/$id/letter/$letterId/export'

const VerificationRoute = VerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRouteImport,
} as any)
const TermServiceRoute = TermServiceRouteImport.update({
  id: '/term-service',
  path: '/term-service',
  getParentRoute: () => rootRouteImport,
} as any)
const SuccessRoute = SuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRequiredRoute = SubscriptionRequiredRouteImport.update({
  id: '/subscription-required',
  path: '/subscription-required',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentFailedRoute = PaymentFailedRouteImport.update({
  id: '/payment-failed',
  path: '/payment-failed',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientPolicyRoute = PatientPolicyRouteImport.update({
  id: '/patient-policy',
  path: '/patient-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const NewPasswordRoute = NewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageSubscriptionRoute = ManageSubscriptionRouteImport.update({
  id: '/manage-subscription',
  path: '/manage-subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountSuccessRoute = DeleteAccountSuccessRouteImport.update({
  id: '/delete-account-success',
  path: '/delete-account-success',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoRouteRoute = SsoRouteRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAccountRouteRoute = CreateAccountRouteRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
  id: '/subscription/',
  path: '/subscription/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const CreateAccountIndexRoute = CreateAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreateAccountRouteRoute,
} as any)
const SubscriptionPlanRoute = SubscriptionPlanRouteImport.update({
  id: '/subscription/$plan',
  path: '/subscription/$plan',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoSigninRoute = SsoSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => SsoRouteRoute,
} as any)
const SsoSelectProviderRoute = SsoSelectProviderRouteImport.update({
  id: '/select-provider',
  path: '/select-provider',
  getParentRoute: () => SsoRouteRoute,
} as any)
const CreateAccountVerifyMobileRoute =
  CreateAccountVerifyMobileRouteImport.update({
    id: '/verify-mobile',
    path: '/verify-mobile',
    getParentRoute: () => CreateAccountRouteRoute,
  } as any)
const CreateAccountProfessionalProfileRoute =
  CreateAccountProfessionalProfileRouteImport.update({
    id: '/professional-profile',
    path: '/professional-profile',
    getParentRoute: () => CreateAccountRouteRoute,
  } as any)
const CreateAccountProfessionalCredentialsRoute =
  CreateAccountProfessionalCredentialsRouteImport.update({
    id: '/professional-credentials',
    path: '/professional-credentials',
    getParentRoute: () => CreateAccountRouteRoute,
  } as any)
const CreateAccountCookieCredentialsRoute =
  CreateAccountCookieCredentialsRouteImport.update({
    id: '/cookie-credentials',
    path: '/cookie-credentials',
    getParentRoute: () => CreateAccountRouteRoute,
  } as any)
const DashboardTeamsRouteRoute = DashboardTeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardInboxRouteRoute = DashboardInboxRouteRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardContactsRouteRoute = DashboardContactsRouteRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardChatRouteRoute = DashboardChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCaseRouteRoute = DashboardCaseRouteRouteImport.update({
  id: '/case',
  path: '/case',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCameraRouteRoute = DashboardCameraRouteRouteImport.update({
  id: '/camera',
  path: '/camera',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCalendarRouteRoute = DashboardCalendarRouteRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBulletinRouteRoute = DashboardBulletinRouteRouteImport.update({
  id: '/bulletin',
  path: '/bulletin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardInboxIndexRoute = DashboardInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardInboxRouteRoute,
} as any)
const DashboardGalleryIndexRoute = DashboardGalleryIndexRouteImport.update({
  id: '/gallery/',
  path: '/gallery/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardContactsIndexRoute = DashboardContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardContactsRouteRoute,
} as any)
const DashboardCaseIndexRoute = DashboardCaseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCaseRouteRoute,
} as any)
const DashboardCameraIndexRoute = DashboardCameraIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCameraRouteRoute,
} as any)
const DashboardCalendarIndexRoute = DashboardCalendarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCalendarRouteRoute,
} as any)
const DashboardBulletinIndexRoute = DashboardBulletinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardBulletinRouteRoute,
} as any)
const DashboardAccountsIndexRoute = DashboardAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardGalleryVideoRoute = DashboardGalleryVideoRouteImport.update({
  id: '/gallery/video',
  path: '/gallery/video',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardGalleryExportsRoute = DashboardGalleryExportsRouteImport.update({
  id: '/gallery/exports',
  path: '/gallery/exports',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardGalleryCameraRoute = DashboardGalleryCameraRouteImport.update({
  id: '/gallery/camera',
  path: '/gallery/camera',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardContactsNoAccessRoute =
  DashboardContactsNoAccessRouteImport.update({
    id: '/no-access',
    path: '/no-access',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardCaseStatusRoute = DashboardCaseStatusRouteImport.update({
  id: '/$status',
  path: '/$status',
  getParentRoute: () => DashboardCaseRouteRoute,
} as any)
const DashboardBulletinSettingRoute =
  DashboardBulletinSettingRouteImport.update({
    id: '/setting',
    path: '/setting',
    getParentRoute: () => DashboardBulletinRouteRoute,
  } as any)
const DashboardTeamsCreateRouteRoute =
  DashboardTeamsCreateRouteRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardTeamsRouteRoute,
  } as any)
const DashboardTeamsIdRouteRoute = DashboardTeamsIdRouteRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardTeamsRouteRoute,
} as any)
const DashboardInboxRemindersRouteRoute =
  DashboardInboxRemindersRouteRouteImport.update({
    id: '/reminders',
    path: '/reminders',
    getParentRoute: () => DashboardInboxRouteRoute,
  } as any)
const DashboardInboxAlertsRouteRoute =
  DashboardInboxAlertsRouteRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => DashboardInboxRouteRoute,
  } as any)
const DashboardGalleryViewRouteRoute =
  DashboardGalleryViewRouteRouteImport.update({
    id: '/gallery/view',
    path: '/gallery/view',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCaseViewRouteRoute = DashboardCaseViewRouteRouteImport.update({
  id: '/view',
  path: '/view',
  getParentRoute: () => DashboardCaseRouteRoute,
} as any)
const DashboardCaseReferralsRouteRoute =
  DashboardCaseReferralsRouteRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCaseRecordsRouteRoute =
  DashboardCaseRecordsRouteRouteImport.update({
    id: '/records',
    path: '/records',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCaseProgressNotesRouteRoute =
  DashboardCaseProgressNotesRouteRouteImport.update({
    id: '/progress-notes',
    path: '/progress-notes',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCalendarEventsRouteRoute =
  DashboardCalendarEventsRouteRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => DashboardCalendarRouteRoute,
  } as any)
const DashboardTeamsCreateIndexRoute =
  DashboardTeamsCreateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardTeamsCreateRouteRoute,
  } as any)
const DashboardTeamsIdIndexRoute = DashboardTeamsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardTeamsIdRouteRoute,
} as any)
const DashboardInboxRemindersIndexRoute =
  DashboardInboxRemindersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInboxRemindersRouteRoute,
  } as any)
const DashboardInboxAlertsIndexRoute =
  DashboardInboxAlertsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardInboxAlertsRouteRoute,
  } as any)
const DashboardContactsDirectoryIndexRoute =
  DashboardContactsDirectoryIndexRouteImport.update({
    id: '/directory/',
    path: '/directory/',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardContactsContactIndexRoute =
  DashboardContactsContactIndexRouteImport.update({
    id: '/contact/',
    path: '/contact/',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardChatSingleIndexRoute =
  DashboardChatSingleIndexRouteImport.update({
    id: '/single/',
    path: '/single/',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardChatGroupIndexRoute = DashboardChatGroupIndexRouteImport.update({
  id: '/group/',
  path: '/group/',
  getParentRoute: () => DashboardChatRouteRoute,
} as any)
const DashboardCaseReferralsIndexRoute =
  DashboardCaseReferralsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseReferralsRouteRoute,
  } as any)
const DashboardCaseRecordsIndexRoute =
  DashboardCaseRecordsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseRecordsRouteRoute,
  } as any)
const DashboardCaseProgressNotesIndexRoute =
  DashboardCaseProgressNotesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseProgressNotesRouteRoute,
  } as any)
const DashboardCasePatientIndexRoute =
  DashboardCasePatientIndexRouteImport.update({
    id: '/patient/',
    path: '/patient/',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCaseCreateIndexRoute =
  DashboardCaseCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardTeamsCreateNameRoute =
  DashboardTeamsCreateNameRouteImport.update({
    id: '/name',
    path: '/name',
    getParentRoute: () => DashboardTeamsCreateRouteRoute,
  } as any)
const DashboardInboxRemindersCreateRoute =
  DashboardInboxRemindersCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardInboxRemindersRouteRoute,
  } as any)
const DashboardInboxRemindersCompletedRoute =
  DashboardInboxRemindersCompletedRouteImport.update({
    id: '/completed',
    path: '/completed',
    getParentRoute: () => DashboardInboxRemindersRouteRoute,
  } as any)
const DashboardInboxRemindersIdRoute =
  DashboardInboxRemindersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardInboxRemindersRouteRoute,
  } as any)
const DashboardGalleryViewIdRoute = DashboardGalleryViewIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardGalleryViewRouteRoute,
} as any)
const DashboardContactsMemberIdRoute =
  DashboardContactsMemberIdRouteImport.update({
    id: '/member/$id',
    path: '/member/$id',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardChatSingleCreateRoute =
  DashboardChatSingleCreateRouteImport.update({
    id: '/single/create',
    path: '/single/create',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardChatMessageIdRoute = DashboardChatMessageIdRouteImport.update({
  id: '/message/$id',
  path: '/message/$id',
  getParentRoute: () => DashboardChatRouteRoute,
} as any)
const DashboardChatGroupCreateRoute =
  DashboardChatGroupCreateRouteImport.update({
    id: '/group/create',
    path: '/group/create',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardCaseReferralsTypeRoute =
  DashboardCaseReferralsTypeRouteImport.update({
    id: '/type',
    path: '/type',
    getParentRoute: () => DashboardCaseReferralsRouteRoute,
  } as any)
const DashboardCaseReferralsSuccessRoute =
  DashboardCaseReferralsSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => DashboardCaseReferralsRouteRoute,
  } as any)
const DashboardCaseReferralsMessageRoute =
  DashboardCaseReferralsMessageRouteImport.update({
    id: '/message',
    path: '/message',
    getParentRoute: () => DashboardCaseReferralsRouteRoute,
  } as any)
const DashboardCaseReferralsContactRoute =
  DashboardCaseReferralsContactRouteImport.update({
    id: '/contact',
    path: '/contact',
    getParentRoute: () => DashboardCaseReferralsRouteRoute,
  } as any)
const DashboardCaseRecordsClosedRoute =
  DashboardCaseRecordsClosedRouteImport.update({
    id: '/closed',
    path: '/closed',
    getParentRoute: () => DashboardCaseRecordsRouteRoute,
  } as any)
const DashboardCaseProgressNotesClosedRoute =
  DashboardCaseProgressNotesClosedRouteImport.update({
    id: '/closed',
    path: '/closed',
    getParentRoute: () => DashboardCaseProgressNotesRouteRoute,
  } as any)
const DashboardCaseMessageIdRoute = DashboardCaseMessageIdRouteImport.update({
  id: '/message/$id',
  path: '/message/$id',
  getParentRoute: () => DashboardCaseRouteRoute,
} as any)
const DashboardCalendarEventsCreateRoute =
  DashboardCalendarEventsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardCalendarEventsRouteRoute,
  } as any)
const DashboardTeamsIdMembersRouteRoute =
  DashboardTeamsIdMembersRouteRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardTeamsIdRouteRoute,
  } as any)
const DashboardTeamsIdEditRouteRoute =
  DashboardTeamsIdEditRouteRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardTeamsIdRouteRoute,
  } as any)
const DashboardChatSingleHemiRouteRoute =
  DashboardChatSingleHemiRouteRouteImport.update({
    id: '/single/hemi',
    path: '/single/hemi',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardChatSingleIdRouteRoute =
  DashboardChatSingleIdRouteRouteImport.update({
    id: '/single/$id',
    path: '/single/$id',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardChatGroupIdRouteRoute =
  DashboardChatGroupIdRouteRouteImport.update({
    id: '/group/$id',
    path: '/group/$id',
    getParentRoute: () => DashboardChatRouteRoute,
  } as any)
const DashboardCaseViewIdRouteRoute =
  DashboardCaseViewIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardCaseViewRouteRoute,
  } as any)
const DashboardCalendarEventsIdRouteRoute =
  DashboardCalendarEventsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => DashboardCalendarEventsRouteRoute,
  } as any)
const DashboardTeamsIdEditIndexRoute =
  DashboardTeamsIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardTeamsIdEditRouteRoute,
  } as any)
const DashboardContactsDirectoryTeamsIndexRoute =
  DashboardContactsDirectoryTeamsIndexRouteImport.update({
    id: '/directory/teams/',
    path: '/directory/teams/',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardContactsContactTeamsIndexRoute =
  DashboardContactsContactTeamsIndexRouteImport.update({
    id: '/contact/teams/',
    path: '/contact/teams/',
    getParentRoute: () => DashboardContactsRouteRoute,
  } as any)
const DashboardChatSingleHemiIndexRoute =
  DashboardChatSingleHemiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardChatSingleHemiRouteRoute,
  } as any)
const DashboardChatGroupIdIndexRoute =
  DashboardChatGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardChatGroupIdRouteRoute,
  } as any)
const DashboardCaseViewIdIndexRoute =
  DashboardCaseViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseCreateExistIndexRoute =
  DashboardCaseCreateExistIndexRouteImport.update({
    id: '/create/exist/',
    path: '/create/exist/',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardAccountsSettingsProfileIndexRoute =
  DashboardAccountsSettingsProfileIndexRouteImport.update({
    id: '/accounts/settings/profile/',
    path: '/accounts/settings/profile/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountIndexRoute =
  DashboardAccountsSettingsAccountIndexRouteImport.update({
    id: '/accounts/settings/account/',
    path: '/accounts/settings/account/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTeamsIdMembersSearchRoute =
  DashboardTeamsIdMembersSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => DashboardTeamsIdMembersRouteRoute,
  } as any)
const DashboardTeamsIdEditMembersRoute =
  DashboardTeamsIdEditMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardTeamsIdEditRouteRoute,
  } as any)
const DashboardChatSingleIdChannelNameRoute =
  DashboardChatSingleIdChannelNameRouteImport.update({
    id: '/$channelName',
    path: '/$channelName',
    getParentRoute: () => DashboardChatSingleIdRouteRoute,
  } as any)
const DashboardChatGroupIdMembersRoute =
  DashboardChatGroupIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardChatGroupIdRouteRoute,
  } as any)
const DashboardChatGroupIdEditRoute =
  DashboardChatGroupIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardChatGroupIdRouteRoute,
  } as any)
const DashboardChatGroupIdDetailRoute =
  DashboardChatGroupIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => DashboardChatGroupIdRouteRoute,
  } as any)
const DashboardChatGroupIdChannelNameRoute =
  DashboardChatGroupIdChannelNameRouteImport.update({
    id: '/$channelName',
    path: '/$channelName',
    getParentRoute: () => DashboardChatGroupIdRouteRoute,
  } as any)
const DashboardCaseViewIdSearchRoute =
  DashboardCaseViewIdSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdExportRoute =
  DashboardCaseViewIdExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdDetailRoute =
  DashboardCaseViewIdDetailRouteImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseCreateExistRequestCompleteRoute =
  DashboardCaseCreateExistRequestCompleteRouteImport.update({
    id: '/create/exist/request-complete',
    path: '/create/exist/request-complete',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCalendarEventsIdEditRoute =
  DashboardCalendarEventsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DashboardCalendarEventsIdRouteRoute,
  } as any)
const DashboardAccountsSettingsProfileInformationRoute =
  DashboardAccountsSettingsProfileInformationRouteImport.update({
    id: '/accounts/settings/profile/information',
    path: '/accounts/settings/profile/information',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsProfileCredentialsRoute =
  DashboardAccountsSettingsProfileCredentialsRouteImport.update({
    id: '/accounts/settings/profile/credentials',
    path: '/accounts/settings/profile/credentials',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountVerifyPhoneNumberRoute =
  DashboardAccountsSettingsAccountVerifyPhoneNumberRouteImport.update({
    id: '/accounts/settings/account/verify-phone-number',
    path: '/accounts/settings/account/verify-phone-number',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountNewPasswordRoute =
  DashboardAccountsSettingsAccountNewPasswordRouteImport.update({
    id: '/accounts/settings/account/new-password',
    path: '/accounts/settings/account/new-password',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountDeleteAccountRoute =
  DashboardAccountsSettingsAccountDeleteAccountRouteImport.update({
    id: '/accounts/settings/account/delete-account',
    path: '/accounts/settings/account/delete-account',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountChangePhoneNumberRoute =
  DashboardAccountsSettingsAccountChangePhoneNumberRouteImport.update({
    id: '/accounts/settings/account/change-phone-number',
    path: '/accounts/settings/account/change-phone-number',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountChangePasswordRoute =
  DashboardAccountsSettingsAccountChangePasswordRouteImport.update({
    id: '/accounts/settings/account/change-password',
    path: '/accounts/settings/account/change-password',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAccountsSettingsAccountChangeEmailRoute =
  DashboardAccountsSettingsAccountChangeEmailRouteImport.update({
    id: '/accounts/settings/account/change-email',
    path: '/accounts/settings/account/change-email',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCaseViewIdMembersRouteRoute =
  DashboardCaseViewIdMembersRouteRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdLetterRouteRoute =
  DashboardCaseViewIdLetterRouteRouteImport.update({
    id: '/letter',
    path: '/letter',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdCaseInfoRouteRoute =
  DashboardCaseViewIdCaseInfoRouteRouteImport.update({
    id: '/case-info',
    path: '/case-info',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdPatientVisitsIndexRoute =
  DashboardCaseViewIdPatientVisitsIndexRouteImport.update({
    id: '/patient-visits/',
    path: '/patient-visits/',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdMembersIndexRoute =
  DashboardCaseViewIdMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseViewIdMembersRouteRoute,
  } as any)
const DashboardCaseViewIdMedicalNoteIndexRoute =
  DashboardCaseViewIdMedicalNoteIndexRouteImport.update({
    id: '/medical-note/',
    path: '/medical-note/',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdPatientVisitsCreateRoute =
  DashboardCaseViewIdPatientVisitsCreateRouteImport.update({
    id: '/patient-visits/create',
    path: '/patient-visits/create',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseViewIdMembersExternalRoute =
  DashboardCaseViewIdMembersExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => DashboardCaseViewIdMembersRouteRoute,
  } as any)
const DashboardCaseViewIdMedicalNoteCreateRoute =
  DashboardCaseViewIdMedicalNoteCreateRouteImport.update({
    id: '/medical-note/create',
    path: '/medical-note/create',
    getParentRoute: () => DashboardCaseViewIdRouteRoute,
  } as any)
const DashboardCaseCreateExistRequestCaseIdRoute =
  DashboardCaseCreateExistRequestCaseIdRouteImport.update({
    id: '/create/exist/request/$caseId',
    path: '/create/exist/request/$caseId',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCaseCreateExistPatientPatientIcRoute =
  DashboardCaseCreateExistPatientPatientIcRouteImport.update({
    id: '/create/exist/patient/$patientIc',
    path: '/create/exist/patient/$patientIc',
    getParentRoute: () => DashboardCaseRouteRoute,
  } as any)
const DashboardCaseViewIdLetterNewRouteRoute =
  DashboardCaseViewIdLetterNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardCaseViewIdLetterRouteRoute,
  } as any)
const DashboardCaseViewIdLetterLetterIdRouteRoute =
  DashboardCaseViewIdLetterLetterIdRouteRouteImport.update({
    id: '/$letterId',
    path: '/$letterId',
    getParentRoute: () => DashboardCaseViewIdLetterRouteRoute,
  } as any)
const DashboardCaseViewIdCaseInfoTypeRouteRoute =
  DashboardCaseViewIdCaseInfoTypeRouteRouteImport.update({
    id: '/$type',
    path: '/$type',
    getParentRoute: () => DashboardCaseViewIdCaseInfoRouteRoute,
  } as any)
const DashboardCaseViewIdLetterNewIndexRoute =
  DashboardCaseViewIdLetterNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseViewIdLetterNewRouteRoute,
  } as any)
const DashboardCaseViewIdLetterLetterIdIndexRoute =
  DashboardCaseViewIdLetterLetterIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseViewIdLetterLetterIdRouteRoute,
  } as any)
const DashboardCaseViewIdCaseInfoTypeIndexRoute =
  DashboardCaseViewIdCaseInfoTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCaseViewIdCaseInfoTypeRouteRoute,
  } as any)
const DashboardCaseViewIdLetterNewInfoRoute =
  DashboardCaseViewIdLetterNewInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => DashboardCaseViewIdLetterNewRouteRoute,
  } as any)
const DashboardCaseViewIdLetterLetterIdUpdateRoute =
  DashboardCaseViewIdLetterLetterIdUpdateRouteImport.update({
    id: '/update',
    path: '/update',
    getParentRoute: () => DashboardCaseViewIdLetterLetterIdRouteRoute,
  } as any)
const DashboardCaseViewIdLetterLetterIdExportRoute =
  DashboardCaseViewIdLetterLetterIdExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => DashboardCaseViewIdLetterLetterIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create-account': typeof CreateAccountRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/sso': typeof SsoRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/download': typeof DownloadRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/manage-subscription': typeof ManageSubscriptionRoute
  '/new-password': typeof NewPasswordRoute
  '/patient-policy': typeof PatientPolicyRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/subscription-required': typeof SubscriptionRequiredRoute
  '/success': typeof SuccessRoute
  '/term-service': typeof TermServiceRoute
  '/verification': typeof VerificationRoute
  '/dashboard/bulletin': typeof DashboardBulletinRouteRouteWithChildren
  '/dashboard/calendar': typeof DashboardCalendarRouteRouteWithChildren
  '/dashboard/camera': typeof DashboardCameraRouteRouteWithChildren
  '/dashboard/case': typeof DashboardCaseRouteRouteWithChildren
  '/dashboard/chat': typeof DashboardChatRouteRouteWithChildren
  '/dashboard/contacts': typeof DashboardContactsRouteRouteWithChildren
  '/dashboard/inbox': typeof DashboardInboxRouteRouteWithChildren
  '/dashboard/teams': typeof DashboardTeamsRouteRouteWithChildren
  '/create-account/cookie-credentials': typeof CreateAccountCookieCredentialsRoute
  '/create-account/professional-credentials': typeof CreateAccountProfessionalCredentialsRoute
  '/create-account/professional-profile': typeof CreateAccountProfessionalProfileRoute
  '/create-account/verify-mobile': typeof CreateAccountVerifyMobileRoute
  '/sso/select-provider': typeof SsoSelectProviderRoute
  '/sso/signin': typeof SsoSigninRoute
  '/subscription/$plan': typeof SubscriptionPlanRoute
  '/create-account/': typeof CreateAccountIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/dashboard/calendar/events': typeof DashboardCalendarEventsRouteRouteWithChildren
  '/dashboard/case/progress-notes': typeof DashboardCaseProgressNotesRouteRouteWithChildren
  '/dashboard/case/records': typeof DashboardCaseRecordsRouteRouteWithChildren
  '/dashboard/case/referrals': typeof DashboardCaseReferralsRouteRouteWithChildren
  '/dashboard/case/view': typeof DashboardCaseViewRouteRouteWithChildren
  '/dashboard/gallery/view': typeof DashboardGalleryViewRouteRouteWithChildren
  '/dashboard/inbox/alerts': typeof DashboardInboxAlertsRouteRouteWithChildren
  '/dashboard/inbox/reminders': typeof DashboardInboxRemindersRouteRouteWithChildren
  '/dashboard/teams/$id': typeof DashboardTeamsIdRouteRouteWithChildren
  '/dashboard/teams/create': typeof DashboardTeamsCreateRouteRouteWithChildren
  '/dashboard/bulletin/setting': typeof DashboardBulletinSettingRoute
  '/dashboard/case/$status': typeof DashboardCaseStatusRoute
  '/dashboard/contacts/no-access': typeof DashboardContactsNoAccessRoute
  '/dashboard/gallery/camera': typeof DashboardGalleryCameraRoute
  '/dashboard/gallery/exports': typeof DashboardGalleryExportsRoute
  '/dashboard/gallery/video': typeof DashboardGalleryVideoRoute
  '/dashboard/accounts': typeof DashboardAccountsIndexRoute
  '/dashboard/bulletin/': typeof DashboardBulletinIndexRoute
  '/dashboard/calendar/': typeof DashboardCalendarIndexRoute
  '/dashboard/camera/': typeof DashboardCameraIndexRoute
  '/dashboard/case/': typeof DashboardCaseIndexRoute
  '/dashboard/contacts/': typeof DashboardContactsIndexRoute
  '/dashboard/gallery': typeof DashboardGalleryIndexRoute
  '/dashboard/inbox/': typeof DashboardInboxIndexRoute
  '/dashboard/calendar/events/$id': typeof DashboardCalendarEventsIdRouteRouteWithChildren
  '/dashboard/case/view/$id': typeof DashboardCaseViewIdRouteRouteWithChildren
  '/dashboard/chat/group/$id': typeof DashboardChatGroupIdRouteRouteWithChildren
  '/dashboard/chat/single/$id': typeof DashboardChatSingleIdRouteRouteWithChildren
  '/dashboard/chat/single/hemi': typeof DashboardChatSingleHemiRouteRouteWithChildren
  '/dashboard/teams/$id/edit': typeof DashboardTeamsIdEditRouteRouteWithChildren
  '/dashboard/teams/$id/members': typeof DashboardTeamsIdMembersRouteRouteWithChildren
  '/dashboard/calendar/events/create': typeof DashboardCalendarEventsCreateRoute
  '/dashboard/case/message/$id': typeof DashboardCaseMessageIdRoute
  '/dashboard/case/progress-notes/closed': typeof DashboardCaseProgressNotesClosedRoute
  '/dashboard/case/records/closed': typeof DashboardCaseRecordsClosedRoute
  '/dashboard/case/referrals/contact': typeof DashboardCaseReferralsContactRoute
  '/dashboard/case/referrals/message': typeof DashboardCaseReferralsMessageRoute
  '/dashboard/case/referrals/success': typeof DashboardCaseReferralsSuccessRoute
  '/dashboard/case/referrals/type': typeof DashboardCaseReferralsTypeRoute
  '/dashboard/chat/group/create': typeof DashboardChatGroupCreateRoute
  '/dashboard/chat/message/$id': typeof DashboardChatMessageIdRoute
  '/dashboard/chat/single/create': typeof DashboardChatSingleCreateRoute
  '/dashboard/contacts/member/$id': typeof DashboardContactsMemberIdRoute
  '/dashboard/gallery/view/$id': typeof DashboardGalleryViewIdRoute
  '/dashboard/inbox/reminders/$id': typeof DashboardInboxRemindersIdRoute
  '/dashboard/inbox/reminders/completed': typeof DashboardInboxRemindersCompletedRoute
  '/dashboard/inbox/reminders/create': typeof DashboardInboxRemindersCreateRoute
  '/dashboard/teams/create/name': typeof DashboardTeamsCreateNameRoute
  '/dashboard/case/create': typeof DashboardCaseCreateIndexRoute
  '/dashboard/case/patient': typeof DashboardCasePatientIndexRoute
  '/dashboard/case/progress-notes/': typeof DashboardCaseProgressNotesIndexRoute
  '/dashboard/case/records/': typeof DashboardCaseRecordsIndexRoute
  '/dashboard/case/referrals/': typeof DashboardCaseReferralsIndexRoute
  '/dashboard/chat/group': typeof DashboardChatGroupIndexRoute
  '/dashboard/chat/single': typeof DashboardChatSingleIndexRoute
  '/dashboard/contacts/contact': typeof DashboardContactsContactIndexRoute
  '/dashboard/contacts/directory': typeof DashboardContactsDirectoryIndexRoute
  '/dashboard/inbox/alerts/': typeof DashboardInboxAlertsIndexRoute
  '/dashboard/inbox/reminders/': typeof DashboardInboxRemindersIndexRoute
  '/dashboard/teams/$id/': typeof DashboardTeamsIdIndexRoute
  '/dashboard/teams/create/': typeof DashboardTeamsCreateIndexRoute
  '/dashboard/case/view/$id/case-info': typeof DashboardCaseViewIdCaseInfoRouteRouteWithChildren
  '/dashboard/case/view/$id/letter': typeof DashboardCaseViewIdLetterRouteRouteWithChildren
  '/dashboard/case/view/$id/members': typeof DashboardCaseViewIdMembersRouteRouteWithChildren
  '/dashboard/accounts/settings/account/change-email': typeof DashboardAccountsSettingsAccountChangeEmailRoute
  '/dashboard/accounts/settings/account/change-password': typeof DashboardAccountsSettingsAccountChangePasswordRoute
  '/dashboard/accounts/settings/account/change-phone-number': typeof DashboardAccountsSettingsAccountChangePhoneNumberRoute
  '/dashboard/accounts/settings/account/delete-account': typeof DashboardAccountsSettingsAccountDeleteAccountRoute
  '/dashboard/accounts/settings/account/new-password': typeof DashboardAccountsSettingsAccountNewPasswordRoute
  '/dashboard/accounts/settings/account/verify-phone-number': typeof DashboardAccountsSettingsAccountVerifyPhoneNumberRoute
  '/dashboard/accounts/settings/profile/credentials': typeof DashboardAccountsSettingsProfileCredentialsRoute
  '/dashboard/accounts/settings/profile/information': typeof DashboardAccountsSettingsProfileInformationRoute
  '/dashboard/calendar/events/$id/edit': typeof DashboardCalendarEventsIdEditRoute
  '/dashboard/case/create/exist/request-complete': typeof DashboardCaseCreateExistRequestCompleteRoute
  '/dashboard/case/view/$id/detail': typeof DashboardCaseViewIdDetailRoute
  '/dashboard/case/view/$id/export': typeof DashboardCaseViewIdExportRoute
  '/dashboard/case/view/$id/search': typeof DashboardCaseViewIdSearchRoute
  '/dashboard/chat/group/$id/$channelName': typeof DashboardChatGroupIdChannelNameRoute
  '/dashboard/chat/group/$id/detail': typeof DashboardChatGroupIdDetailRoute
  '/dashboard/chat/group/$id/edit': typeof DashboardChatGroupIdEditRoute
  '/dashboard/chat/group/$id/members': typeof DashboardChatGroupIdMembersRoute
  '/dashboard/chat/single/$id/$channelName': typeof DashboardChatSingleIdChannelNameRoute
  '/dashboard/teams/$id/edit/members': typeof DashboardTeamsIdEditMembersRoute
  '/dashboard/teams/$id/members/search': typeof DashboardTeamsIdMembersSearchRoute
  '/dashboard/accounts/settings/account': typeof DashboardAccountsSettingsAccountIndexRoute
  '/dashboard/accounts/settings/profile': typeof DashboardAccountsSettingsProfileIndexRoute
  '/dashboard/case/create/exist': typeof DashboardCaseCreateExistIndexRoute
  '/dashboard/case/view/$id/': typeof DashboardCaseViewIdIndexRoute
  '/dashboard/chat/group/$id/': typeof DashboardChatGroupIdIndexRoute
  '/dashboard/chat/single/hemi/': typeof DashboardChatSingleHemiIndexRoute
  '/dashboard/contacts/contact/teams': typeof DashboardContactsContactTeamsIndexRoute
  '/dashboard/contacts/directory/teams': typeof DashboardContactsDirectoryTeamsIndexRoute
  '/dashboard/teams/$id/edit/': typeof DashboardTeamsIdEditIndexRoute
  '/dashboard/case/view/$id/case-info/$type': typeof DashboardCaseViewIdCaseInfoTypeRouteRouteWithChildren
  '/dashboard/case/view/$id/letter/$letterId': typeof DashboardCaseViewIdLetterLetterIdRouteRouteWithChildren
  '/dashboard/case/view/$id/letter/new': typeof DashboardCaseViewIdLetterNewRouteRouteWithChildren
  '/dashboard/case/create/exist/patient/$patientIc': typeof DashboardCaseCreateExistPatientPatientIcRoute
  '/dashboard/case/create/exist/request/$caseId': typeof DashboardCaseCreateExistRequestCaseIdRoute
  '/dashboard/case/view/$id/medical-note/create': typeof DashboardCaseViewIdMedicalNoteCreateRoute
  '/dashboard/case/view/$id/members/external': typeof DashboardCaseViewIdMembersExternalRoute
  '/dashboard/case/view/$id/patient-visits/create': typeof DashboardCaseViewIdPatientVisitsCreateRoute
  '/dashboard/case/view/$id/medical-note': typeof DashboardCaseViewIdMedicalNoteIndexRoute
  '/dashboard/case/view/$id/members/': typeof DashboardCaseViewIdMembersIndexRoute
  '/dashboard/case/view/$id/patient-visits': typeof DashboardCaseViewIdPatientVisitsIndexRoute
  '/dashboard/case/view/$id/letter/$letterId/export': typeof DashboardCaseViewIdLetterLetterIdExportRoute
  '/dashboard/case/view/$id/letter/$letterId/update': typeof DashboardCaseViewIdLetterLetterIdUpdateRoute
  '/dashboard/case/view/$id/letter/new/info': typeof DashboardCaseViewIdLetterNewInfoRoute
  '/dashboard/case/view/$id/case-info/$type/': typeof DashboardCaseViewIdCaseInfoTypeIndexRoute
  '/dashboard/case/view/$id/letter/$letterId/': typeof DashboardCaseViewIdLetterLetterIdIndexRoute
  '/dashboard/case/view/$id/letter/new/': typeof DashboardCaseViewIdLetterNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sso': typeof SsoRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/download': typeof DownloadRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/manage-subscription': typeof ManageSubscriptionRoute
  '/new-password': typeof NewPasswordRoute
  '/patient-policy': typeof PatientPolicyRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/subscription-required': typeof SubscriptionRequiredRoute
  '/success': typeof SuccessRoute
  '/term-service': typeof TermServiceRoute
  '/verification': typeof VerificationRoute
  '/dashboard/chat': typeof DashboardChatRouteRouteWithChildren
  '/dashboard/teams': typeof DashboardTeamsRouteRouteWithChildren
  '/create-account/cookie-credentials': typeof CreateAccountCookieCredentialsRoute
  '/create-account/professional-credentials': typeof CreateAccountProfessionalCredentialsRoute
  '/create-account/professional-profile': typeof CreateAccountProfessionalProfileRoute
  '/create-account/verify-mobile': typeof CreateAccountVerifyMobileRoute
  '/sso/select-provider': typeof SsoSelectProviderRoute
  '/sso/signin': typeof SsoSigninRoute
  '/subscription/$plan': typeof SubscriptionPlanRoute
  '/create-account': typeof CreateAccountIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/dashboard/calendar/events': typeof DashboardCalendarEventsRouteRouteWithChildren
  '/dashboard/case/view': typeof DashboardCaseViewRouteRouteWithChildren
  '/dashboard/gallery/view': typeof DashboardGalleryViewRouteRouteWithChildren
  '/dashboard/bulletin/setting': typeof DashboardBulletinSettingRoute
  '/dashboard/case/$status': typeof DashboardCaseStatusRoute
  '/dashboard/contacts/no-access': typeof DashboardContactsNoAccessRoute
  '/dashboard/gallery/camera': typeof DashboardGalleryCameraRoute
  '/dashboard/gallery/exports': typeof DashboardGalleryExportsRoute
  '/dashboard/gallery/video': typeof DashboardGalleryVideoRoute
  '/dashboard/accounts': typeof DashboardAccountsIndexRoute
  '/dashboard/bulletin': typeof DashboardBulletinIndexRoute
  '/dashboard/calendar': typeof DashboardCalendarIndexRoute
  '/dashboard/camera': typeof DashboardCameraIndexRoute
  '/dashboard/case': typeof DashboardCaseIndexRoute
  '/dashboard/contacts': typeof DashboardContactsIndexRoute
  '/dashboard/gallery': typeof DashboardGalleryIndexRoute
  '/dashboard/inbox': typeof DashboardInboxIndexRoute
  '/dashboard/calendar/events/$id': typeof DashboardCalendarEventsIdRouteRouteWithChildren
  '/dashboard/chat/single/$id': typeof DashboardChatSingleIdRouteRouteWithChildren
  '/dashboard/teams/$id/members': typeof DashboardTeamsIdMembersRouteRouteWithChildren
  '/dashboard/calendar/events/create': typeof DashboardCalendarEventsCreateRoute
  '/dashboard/case/message/$id': typeof DashboardCaseMessageIdRoute
  '/dashboard/case/progress-notes/closed': typeof DashboardCaseProgressNotesClosedRoute
  '/dashboard/case/records/closed': typeof DashboardCaseRecordsClosedRoute
  '/dashboard/case/referrals/contact': typeof DashboardCaseReferralsContactRoute
  '/dashboard/case/referrals/message': typeof DashboardCaseReferralsMessageRoute
  '/dashboard/case/referrals/success': typeof DashboardCaseReferralsSuccessRoute
  '/dashboard/case/referrals/type': typeof DashboardCaseReferralsTypeRoute
  '/dashboard/chat/group/create': typeof DashboardChatGroupCreateRoute
  '/dashboard/chat/message/$id': typeof DashboardChatMessageIdRoute
  '/dashboard/chat/single/create': typeof DashboardChatSingleCreateRoute
  '/dashboard/contacts/member/$id': typeof DashboardContactsMemberIdRoute
  '/dashboard/gallery/view/$id': typeof DashboardGalleryViewIdRoute
  '/dashboard/inbox/reminders/$id': typeof DashboardInboxRemindersIdRoute
  '/dashboard/inbox/reminders/completed': typeof DashboardInboxRemindersCompletedRoute
  '/dashboard/inbox/reminders/create': typeof DashboardInboxRemindersCreateRoute
  '/dashboard/teams/create/name': typeof DashboardTeamsCreateNameRoute
  '/dashboard/case/create': typeof DashboardCaseCreateIndexRoute
  '/dashboard/case/patient': typeof DashboardCasePatientIndexRoute
  '/dashboard/case/progress-notes': typeof DashboardCaseProgressNotesIndexRoute
  '/dashboard/case/records': typeof DashboardCaseRecordsIndexRoute
  '/dashboard/case/referrals': typeof DashboardCaseReferralsIndexRoute
  '/dashboard/chat/group': typeof DashboardChatGroupIndexRoute
  '/dashboard/chat/single': typeof DashboardChatSingleIndexRoute
  '/dashboard/contacts/contact': typeof DashboardContactsContactIndexRoute
  '/dashboard/contacts/directory': typeof DashboardContactsDirectoryIndexRoute
  '/dashboard/inbox/alerts': typeof DashboardInboxAlertsIndexRoute
  '/dashboard/inbox/reminders': typeof DashboardInboxRemindersIndexRoute
  '/dashboard/teams/$id': typeof DashboardTeamsIdIndexRoute
  '/dashboard/teams/create': typeof DashboardTeamsCreateIndexRoute
  '/dashboard/case/view/$id/case-info': typeof DashboardCaseViewIdCaseInfoRouteRouteWithChildren
  '/dashboard/case/view/$id/letter': typeof DashboardCaseViewIdLetterRouteRouteWithChildren
  '/dashboard/accounts/settings/account/change-email': typeof DashboardAccountsSettingsAccountChangeEmailRoute
  '/dashboard/accounts/settings/account/change-password': typeof DashboardAccountsSettingsAccountChangePasswordRoute
  '/dashboard/accounts/settings/account/change-phone-number': typeof DashboardAccountsSettingsAccountChangePhoneNumberRoute
  '/dashboard/accounts/settings/account/delete-account': typeof DashboardAccountsSettingsAccountDeleteAccountRoute
  '/dashboard/accounts/settings/account/new-password': typeof DashboardAccountsSettingsAccountNewPasswordRoute
  '/dashboard/accounts/settings/account/verify-phone-number': typeof DashboardAccountsSettingsAccountVerifyPhoneNumberRoute
  '/dashboard/accounts/settings/profile/credentials': typeof DashboardAccountsSettingsProfileCredentialsRoute
  '/dashboard/accounts/settings/profile/information': typeof DashboardAccountsSettingsProfileInformationRoute
  '/dashboard/calendar/events/$id/edit': typeof DashboardCalendarEventsIdEditRoute
  '/dashboard/case/create/exist/request-complete': typeof DashboardCaseCreateExistRequestCompleteRoute
  '/dashboard/case/view/$id/detail': typeof DashboardCaseViewIdDetailRoute
  '/dashboard/case/view/$id/export': typeof DashboardCaseViewIdExportRoute
  '/dashboard/case/view/$id/search': typeof DashboardCaseViewIdSearchRoute
  '/dashboard/chat/group/$id/$channelName': typeof DashboardChatGroupIdChannelNameRoute
  '/dashboard/chat/group/$id/detail': typeof DashboardChatGroupIdDetailRoute
  '/dashboard/chat/group/$id/edit': typeof DashboardChatGroupIdEditRoute
  '/dashboard/chat/group/$id/members': typeof DashboardChatGroupIdMembersRoute
  '/dashboard/chat/single/$id/$channelName': typeof DashboardChatSingleIdChannelNameRoute
  '/dashboard/teams/$id/edit/members': typeof DashboardTeamsIdEditMembersRoute
  '/dashboard/teams/$id/members/search': typeof DashboardTeamsIdMembersSearchRoute
  '/dashboard/accounts/settings/account': typeof DashboardAccountsSettingsAccountIndexRoute
  '/dashboard/accounts/settings/profile': typeof DashboardAccountsSettingsProfileIndexRoute
  '/dashboard/case/create/exist': typeof DashboardCaseCreateExistIndexRoute
  '/dashboard/case/view/$id': typeof DashboardCaseViewIdIndexRoute
  '/dashboard/chat/group/$id': typeof DashboardChatGroupIdIndexRoute
  '/dashboard/chat/single/hemi': typeof DashboardChatSingleHemiIndexRoute
  '/dashboard/contacts/contact/teams': typeof DashboardContactsContactTeamsIndexRoute
  '/dashboard/contacts/directory/teams': typeof DashboardContactsDirectoryTeamsIndexRoute
  '/dashboard/teams/$id/edit': typeof DashboardTeamsIdEditIndexRoute
  '/dashboard/case/create/exist/patient/$patientIc': typeof DashboardCaseCreateExistPatientPatientIcRoute
  '/dashboard/case/create/exist/request/$caseId': typeof DashboardCaseCreateExistRequestCaseIdRoute
  '/dashboard/case/view/$id/medical-note/create': typeof DashboardCaseViewIdMedicalNoteCreateRoute
  '/dashboard/case/view/$id/members/external': typeof DashboardCaseViewIdMembersExternalRoute
  '/dashboard/case/view/$id/patient-visits/create': typeof DashboardCaseViewIdPatientVisitsCreateRoute
  '/dashboard/case/view/$id/medical-note': typeof DashboardCaseViewIdMedicalNoteIndexRoute
  '/dashboard/case/view/$id/members': typeof DashboardCaseViewIdMembersIndexRoute
  '/dashboard/case/view/$id/patient-visits': typeof DashboardCaseViewIdPatientVisitsIndexRoute
  '/dashboard/case/view/$id/letter/$letterId/export': typeof DashboardCaseViewIdLetterLetterIdExportRoute
  '/dashboard/case/view/$id/letter/$letterId/update': typeof DashboardCaseViewIdLetterLetterIdUpdateRoute
  '/dashboard/case/view/$id/letter/new/info': typeof DashboardCaseViewIdLetterNewInfoRoute
  '/dashboard/case/view/$id/case-info/$type': typeof DashboardCaseViewIdCaseInfoTypeIndexRoute
  '/dashboard/case/view/$id/letter/$letterId': typeof DashboardCaseViewIdLetterLetterIdIndexRoute
  '/dashboard/case/view/$id/letter/new': typeof DashboardCaseViewIdLetterNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/create-account': typeof CreateAccountRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/sso': typeof SsoRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/delete-account-success': typeof DeleteAccountSuccessRoute
  '/download': typeof DownloadRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/manage-subscription': typeof ManageSubscriptionRoute
  '/new-password': typeof NewPasswordRoute
  '/patient-policy': typeof PatientPolicyRoute
  '/payment-failed': typeof PaymentFailedRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/subscription-required': typeof SubscriptionRequiredRoute
  '/success': typeof SuccessRoute
  '/term-service': typeof TermServiceRoute
  '/verification': typeof VerificationRoute
  '/dashboard/bulletin': typeof DashboardBulletinRouteRouteWithChildren
  '/dashboard/calendar': typeof DashboardCalendarRouteRouteWithChildren
  '/dashboard/camera': typeof DashboardCameraRouteRouteWithChildren
  '/dashboard/case': typeof DashboardCaseRouteRouteWithChildren
  '/dashboard/chat': typeof DashboardChatRouteRouteWithChildren
  '/dashboard/contacts': typeof DashboardContactsRouteRouteWithChildren
  '/dashboard/inbox': typeof DashboardInboxRouteRouteWithChildren
  '/dashboard/teams': typeof DashboardTeamsRouteRouteWithChildren
  '/create-account/cookie-credentials': typeof CreateAccountCookieCredentialsRoute
  '/create-account/professional-credentials': typeof CreateAccountProfessionalCredentialsRoute
  '/create-account/professional-profile': typeof CreateAccountProfessionalProfileRoute
  '/create-account/verify-mobile': typeof CreateAccountVerifyMobileRoute
  '/sso/select-provider': typeof SsoSelectProviderRoute
  '/sso/signin': typeof SsoSigninRoute
  '/subscription/$plan': typeof SubscriptionPlanRoute
  '/create-account/': typeof CreateAccountIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/dashboard/calendar/events': typeof DashboardCalendarEventsRouteRouteWithChildren
  '/dashboard/case/progress-notes': typeof DashboardCaseProgressNotesRouteRouteWithChildren
  '/dashboard/case/records': typeof DashboardCaseRecordsRouteRouteWithChildren
  '/dashboard/case/referrals': typeof DashboardCaseReferralsRouteRouteWithChildren
  '/dashboard/case/view': typeof DashboardCaseViewRouteRouteWithChildren
  '/dashboard/gallery/view': typeof DashboardGalleryViewRouteRouteWithChildren
  '/dashboard/inbox/alerts': typeof DashboardInboxAlertsRouteRouteWithChildren
  '/dashboard/inbox/reminders': typeof DashboardInboxRemindersRouteRouteWithChildren
  '/dashboard/teams/$id': typeof DashboardTeamsIdRouteRouteWithChildren
  '/dashboard/teams/create': typeof DashboardTeamsCreateRouteRouteWithChildren
  '/dashboard/bulletin/setting': typeof DashboardBulletinSettingRoute
  '/dashboard/case/$status': typeof DashboardCaseStatusRoute
  '/dashboard/contacts/no-access': typeof DashboardContactsNoAccessRoute
  '/dashboard/gallery/camera': typeof DashboardGalleryCameraRoute
  '/dashboard/gallery/exports': typeof DashboardGalleryExportsRoute
  '/dashboard/gallery/video': typeof DashboardGalleryVideoRoute
  '/dashboard/accounts/': typeof DashboardAccountsIndexRoute
  '/dashboard/bulletin/': typeof DashboardBulletinIndexRoute
  '/dashboard/calendar/': typeof DashboardCalendarIndexRoute
  '/dashboard/camera/': typeof DashboardCameraIndexRoute
  '/dashboard/case/': typeof DashboardCaseIndexRoute
  '/dashboard/contacts/': typeof DashboardContactsIndexRoute
  '/dashboard/gallery/': typeof DashboardGalleryIndexRoute
  '/dashboard/inbox/': typeof DashboardInboxIndexRoute
  '/dashboard/calendar/events/$id': typeof DashboardCalendarEventsIdRouteRouteWithChildren
  '/dashboard/case/view/$id': typeof DashboardCaseViewIdRouteRouteWithChildren
  '/dashboard/chat/group/$id': typeof DashboardChatGroupIdRouteRouteWithChildren
  '/dashboard/chat/single/$id': typeof DashboardChatSingleIdRouteRouteWithChildren
  '/dashboard/chat/single/hemi': typeof DashboardChatSingleHemiRouteRouteWithChildren
  '/dashboard/teams/$id/edit': typeof DashboardTeamsIdEditRouteRouteWithChildren
  '/dashboard/teams/$id/members': typeof DashboardTeamsIdMembersRouteRouteWithChildren
  '/dashboard/calendar/events/create': typeof DashboardCalendarEventsCreateRoute
  '/dashboard/case/message/$id': typeof DashboardCaseMessageIdRoute
  '/dashboard/case/progress-notes/closed': typeof DashboardCaseProgressNotesClosedRoute
  '/dashboard/case/records/closed': typeof DashboardCaseRecordsClosedRoute
  '/dashboard/case/referrals/contact': typeof DashboardCaseReferralsContactRoute
  '/dashboard/case/referrals/message': typeof DashboardCaseReferralsMessageRoute
  '/dashboard/case/referrals/success': typeof DashboardCaseReferralsSuccessRoute
  '/dashboard/case/referrals/type': typeof DashboardCaseReferralsTypeRoute
  '/dashboard/chat/group/create': typeof DashboardChatGroupCreateRoute
  '/dashboard/chat/message/$id': typeof DashboardChatMessageIdRoute
  '/dashboard/chat/single/create': typeof DashboardChatSingleCreateRoute
  '/dashboard/contacts/member/$id': typeof DashboardContactsMemberIdRoute
  '/dashboard/gallery/view/$id': typeof DashboardGalleryViewIdRoute
  '/dashboard/inbox/reminders/$id': typeof DashboardInboxRemindersIdRoute
  '/dashboard/inbox/reminders/completed': typeof DashboardInboxRemindersCompletedRoute
  '/dashboard/inbox/reminders/create': typeof DashboardInboxRemindersCreateRoute
  '/dashboard/teams/create/name': typeof DashboardTeamsCreateNameRoute
  '/dashboard/case/create/': typeof DashboardCaseCreateIndexRoute
  '/dashboard/case/patient/': typeof DashboardCasePatientIndexRoute
  '/dashboard/case/progress-notes/': typeof DashboardCaseProgressNotesIndexRoute
  '/dashboard/case/records/': typeof DashboardCaseRecordsIndexRoute
  '/dashboard/case/referrals/': typeof DashboardCaseReferralsIndexRoute
  '/dashboard/chat/group/': typeof DashboardChatGroupIndexRoute
  '/dashboard/chat/single/': typeof DashboardChatSingleIndexRoute
  '/dashboard/contacts/contact/': typeof DashboardContactsContactIndexRoute
  '/dashboard/contacts/directory/': typeof DashboardContactsDirectoryIndexRoute
  '/dashboard/inbox/alerts/': typeof DashboardInboxAlertsIndexRoute
  '/dashboard/inbox/reminders/': typeof DashboardInboxRemindersIndexRoute
  '/dashboard/teams/$id/': typeof DashboardTeamsIdIndexRoute
  '/dashboard/teams/create/': typeof DashboardTeamsCreateIndexRoute
  '/dashboard/case/view/$id/case-info': typeof DashboardCaseViewIdCaseInfoRouteRouteWithChildren
  '/dashboard/case/view/$id/letter': typeof DashboardCaseViewIdLetterRouteRouteWithChildren
  '/dashboard/case/view/$id/members': typeof DashboardCaseViewIdMembersRouteRouteWithChildren
  '/dashboard/accounts/settings/account/change-email': typeof DashboardAccountsSettingsAccountChangeEmailRoute
  '/dashboard/accounts/settings/account/change-password': typeof DashboardAccountsSettingsAccountChangePasswordRoute
  '/dashboard/accounts/settings/account/change-phone-number': typeof DashboardAccountsSettingsAccountChangePhoneNumberRoute
  '/dashboard/accounts/settings/account/delete-account': typeof DashboardAccountsSettingsAccountDeleteAccountRoute
  '/dashboard/accounts/settings/account/new-password': typeof DashboardAccountsSettingsAccountNewPasswordRoute
  '/dashboard/accounts/settings/account/verify-phone-number': typeof DashboardAccountsSettingsAccountVerifyPhoneNumberRoute
  '/dashboard/accounts/settings/profile/credentials': typeof DashboardAccountsSettingsProfileCredentialsRoute
  '/dashboard/accounts/settings/profile/information': typeof DashboardAccountsSettingsProfileInformationRoute
  '/dashboard/calendar/events/$id/edit': typeof DashboardCalendarEventsIdEditRoute
  '/dashboard/case/create/exist/request-complete': typeof DashboardCaseCreateExistRequestCompleteRoute
  '/dashboard/case/view/$id/detail': typeof DashboardCaseViewIdDetailRoute
  '/dashboard/case/view/$id/export': typeof DashboardCaseViewIdExportRoute
  '/dashboard/case/view/$id/search': typeof DashboardCaseViewIdSearchRoute
  '/dashboard/chat/group/$id/$channelName': typeof DashboardChatGroupIdChannelNameRoute
  '/dashboard/chat/group/$id/detail': typeof DashboardChatGroupIdDetailRoute
  '/dashboard/chat/group/$id/edit': typeof DashboardChatGroupIdEditRoute
  '/dashboard/chat/group/$id/members': typeof DashboardChatGroupIdMembersRoute
  '/dashboard/chat/single/$id/$channelName': typeof DashboardChatSingleIdChannelNameRoute
  '/dashboard/teams/$id/edit/members': typeof DashboardTeamsIdEditMembersRoute
  '/dashboard/teams/$id/members/search': typeof DashboardTeamsIdMembersSearchRoute
  '/dashboard/accounts/settings/account/': typeof DashboardAccountsSettingsAccountIndexRoute
  '/dashboard/accounts/settings/profile/': typeof DashboardAccountsSettingsProfileIndexRoute
  '/dashboard/case/create/exist/': typeof DashboardCaseCreateExistIndexRoute
  '/dashboard/case/view/$id/': typeof DashboardCaseViewIdIndexRoute
  '/dashboard/chat/group/$id/': typeof DashboardChatGroupIdIndexRoute
  '/dashboard/chat/single/hemi/': typeof DashboardChatSingleHemiIndexRoute
  '/dashboard/contacts/contact/teams/': typeof DashboardContactsContactTeamsIndexRoute
  '/dashboard/contacts/directory/teams/': typeof DashboardContactsDirectoryTeamsIndexRoute
  '/dashboard/teams/$id/edit/': typeof DashboardTeamsIdEditIndexRoute
  '/dashboard/case/view/$id/case-info/$type': typeof DashboardCaseViewIdCaseInfoTypeRouteRouteWithChildren
  '/dashboard/case/view/$id/letter/$letterId': typeof DashboardCaseViewIdLetterLetterIdRouteRouteWithChildren
  '/dashboard/case/view/$id/letter/new': typeof DashboardCaseViewIdLetterNewRouteRouteWithChildren
  '/dashboard/case/create/exist/patient/$patientIc': typeof DashboardCaseCreateExistPatientPatientIcRoute
  '/dashboard/case/create/exist/request/$caseId': typeof DashboardCaseCreateExistRequestCaseIdRoute
  '/dashboard/case/view/$id/medical-note/create': typeof DashboardCaseViewIdMedicalNoteCreateRoute
  '/dashboard/case/view/$id/members/external': typeof DashboardCaseViewIdMembersExternalRoute
  '/dashboard/case/view/$id/patient-visits/create': typeof DashboardCaseViewIdPatientVisitsCreateRoute
  '/dashboard/case/view/$id/medical-note/': typeof DashboardCaseViewIdMedicalNoteIndexRoute
  '/dashboard/case/view/$id/members/': typeof DashboardCaseViewIdMembersIndexRoute
  '/dashboard/case/view/$id/patient-visits/': typeof DashboardCaseViewIdPatientVisitsIndexRoute
  '/dashboard/case/view/$id/letter/$letterId/export': typeof DashboardCaseViewIdLetterLetterIdExportRoute
  '/dashboard/case/view/$id/letter/$letterId/update': typeof DashboardCaseViewIdLetterLetterIdUpdateRoute
  '/dashboard/case/view/$id/letter/new/info': typeof DashboardCaseViewIdLetterNewInfoRoute
  '/dashboard/case/view/$id/case-info/$type/': typeof DashboardCaseViewIdCaseInfoTypeIndexRoute
  '/dashboard/case/view/$id/letter/$letterId/': typeof DashboardCaseViewIdLetterLetterIdIndexRoute
  '/dashboard/case/view/$id/letter/new/': typeof DashboardCaseViewIdLetterNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create-account'
    | '/dashboard'
    | '/sso'
    | '/account'
    | '/cookie-policy'
    | '/delete-account-success'
    | '/download'
    | '/forgot-password'
    | '/manage-subscription'
    | '/new-password'
    | '/patient-policy'
    | '/payment-failed'
    | '/payment-success'
    | '/privacy-policy'
    | '/subscription-required'
    | '/success'
    | '/term-service'
    | '/verification'
    | '/dashboard/bulletin'
    | '/dashboard/calendar'
    | '/dashboard/camera'
    | '/dashboard/case'
    | '/dashboard/chat'
    | '/dashboard/contacts'
    | '/dashboard/inbox'
    | '/dashboard/teams'
    | '/create-account/cookie-credentials'
    | '/create-account/professional-credentials'
    | '/create-account/professional-profile'
    | '/create-account/verify-mobile'
    | '/sso/select-provider'
    | '/sso/signin'
    | '/subscription/$plan'
    | '/create-account/'
    | '/dashboard/'
    | '/subscription'
    | '/dashboard/calendar/events'
    | '/dashboard/case/progress-notes'
    | '/dashboard/case/records'
    | '/dashboard/case/referrals'
    | '/dashboard/case/view'
    | '/dashboard/gallery/view'
    | '/dashboard/inbox/alerts'
    | '/dashboard/inbox/reminders'
    | '/dashboard/teams/$id'
    | '/dashboard/teams/create'
    | '/dashboard/bulletin/setting'
    | '/dashboard/case/$status'
    | '/dashboard/contacts/no-access'
    | '/dashboard/gallery/camera'
    | '/dashboard/gallery/exports'
    | '/dashboard/gallery/video'
    | '/dashboard/accounts'
    | '/dashboard/bulletin/'
    | '/dashboard/calendar/'
    | '/dashboard/camera/'
    | '/dashboard/case/'
    | '/dashboard/contacts/'
    | '/dashboard/gallery'
    | '/dashboard/inbox/'
    | '/dashboard/calendar/events/$id'
    | '/dashboard/case/view/$id'
    | '/dashboard/chat/group/$id'
    | '/dashboard/chat/single/$id'
    | '/dashboard/chat/single/hemi'
    | '/dashboard/teams/$id/edit'
    | '/dashboard/teams/$id/members'
    | '/dashboard/calendar/events/create'
    | '/dashboard/case/message/$id'
    | '/dashboard/case/progress-notes/closed'
    | '/dashboard/case/records/closed'
    | '/dashboard/case/referrals/contact'
    | '/dashboard/case/referrals/message'
    | '/dashboard/case/referrals/success'
    | '/dashboard/case/referrals/type'
    | '/dashboard/chat/group/create'
    | '/dashboard/chat/message/$id'
    | '/dashboard/chat/single/create'
    | '/dashboard/contacts/member/$id'
    | '/dashboard/gallery/view/$id'
    | '/dashboard/inbox/reminders/$id'
    | '/dashboard/inbox/reminders/completed'
    | '/dashboard/inbox/reminders/create'
    | '/dashboard/teams/create/name'
    | '/dashboard/case/create'
    | '/dashboard/case/patient'
    | '/dashboard/case/progress-notes/'
    | '/dashboard/case/records/'
    | '/dashboard/case/referrals/'
    | '/dashboard/chat/group'
    | '/dashboard/chat/single'
    | '/dashboard/contacts/contact'
    | '/dashboard/contacts/directory'
    | '/dashboard/inbox/alerts/'
    | '/dashboard/inbox/reminders/'
    | '/dashboard/teams/$id/'
    | '/dashboard/teams/create/'
    | '/dashboard/case/view/$id/case-info'
    | '/dashboard/case/view/$id/letter'
    | '/dashboard/case/view/$id/members'
    | '/dashboard/accounts/settings/account/change-email'
    | '/dashboard/accounts/settings/account/change-password'
    | '/dashboard/accounts/settings/account/change-phone-number'
    | '/dashboard/accounts/settings/account/delete-account'
    | '/dashboard/accounts/settings/account/new-password'
    | '/dashboard/accounts/settings/account/verify-phone-number'
    | '/dashboard/accounts/settings/profile/credentials'
    | '/dashboard/accounts/settings/profile/information'
    | '/dashboard/calendar/events/$id/edit'
    | '/dashboard/case/create/exist/request-complete'
    | '/dashboard/case/view/$id/detail'
    | '/dashboard/case/view/$id/export'
    | '/dashboard/case/view/$id/search'
    | '/dashboard/chat/group/$id/$channelName'
    | '/dashboard/chat/group/$id/detail'
    | '/dashboard/chat/group/$id/edit'
    | '/dashboard/chat/group/$id/members'
    | '/dashboard/chat/single/$id/$channelName'
    | '/dashboard/teams/$id/edit/members'
    | '/dashboard/teams/$id/members/search'
    | '/dashboard/accounts/settings/account'
    | '/dashboard/accounts/settings/profile'
    | '/dashboard/case/create/exist'
    | '/dashboard/case/view/$id/'
    | '/dashboard/chat/group/$id/'
    | '/dashboard/chat/single/hemi/'
    | '/dashboard/contacts/contact/teams'
    | '/dashboard/contacts/directory/teams'
    | '/dashboard/teams/$id/edit/'
    | '/dashboard/case/view/$id/case-info/$type'
    | '/dashboard/case/view/$id/letter/$letterId'
    | '/dashboard/case/view/$id/letter/new'
    | '/dashboard/case/create/exist/patient/$patientIc'
    | '/dashboard/case/create/exist/request/$caseId'
    | '/dashboard/case/view/$id/medical-note/create'
    | '/dashboard/case/view/$id/members/external'
    | '/dashboard/case/view/$id/patient-visits/create'
    | '/dashboard/case/view/$id/medical-note'
    | '/dashboard/case/view/$id/members/'
    | '/dashboard/case/view/$id/patient-visits'
    | '/dashboard/case/view/$id/letter/$letterId/export'
    | '/dashboard/case/view/$id/letter/$letterId/update'
    | '/dashboard/case/view/$id/letter/new/info'
    | '/dashboard/case/view/$id/case-info/$type/'
    | '/dashboard/case/view/$id/letter/$letterId/'
    | '/dashboard/case/view/$id/letter/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sso'
    | '/account'
    | '/cookie-policy'
    | '/delete-account-success'
    | '/download'
    | '/forgot-password'
    | '/manage-subscription'
    | '/new-password'
    | '/patient-policy'
    | '/payment-failed'
    | '/payment-success'
    | '/privacy-policy'
    | '/subscription-required'
    | '/success'
    | '/term-service'
    | '/verification'
    | '/dashboard/chat'
    | '/dashboard/teams'
    | '/create-account/cookie-credentials'
    | '/create-account/professional-credentials'
    | '/create-account/professional-profile'
    | '/create-account/verify-mobile'
    | '/sso/select-provider'
    | '/sso/signin'
    | '/subscription/$plan'
    | '/create-account'
    | '/dashboard'
    | '/subscription'
    | '/dashboard/calendar/events'
    | '/dashboard/case/view'
    | '/dashboard/gallery/view'
    | '/dashboard/bulletin/setting'
    | '/dashboard/case/$status'
    | '/dashboard/contacts/no-access'
    | '/dashboard/gallery/camera'
    | '/dashboard/gallery/exports'
    | '/dashboard/gallery/video'
    | '/dashboard/accounts'
    | '/dashboard/bulletin'
    | '/dashboard/calendar'
    | '/dashboard/camera'
    | '/dashboard/case'
    | '/dashboard/contacts'
    | '/dashboard/gallery'
    | '/dashboard/inbox'
    | '/dashboard/calendar/events/$id'
    | '/dashboard/chat/single/$id'
    | '/dashboard/teams/$id/members'
    | '/dashboard/calendar/events/create'
    | '/dashboard/case/message/$id'
    | '/dashboard/case/progress-notes/closed'
    | '/dashboard/case/records/closed'
    | '/dashboard/case/referrals/contact'
    | '/dashboard/case/referrals/message'
    | '/dashboard/case/referrals/success'
    | '/dashboard/case/referrals/type'
    | '/dashboard/chat/group/create'
    | '/dashboard/chat/message/$id'
    | '/dashboard/chat/single/create'
    | '/dashboard/contacts/member/$id'
    | '/dashboard/gallery/view/$id'
    | '/dashboard/inbox/reminders/$id'
    | '/dashboard/inbox/reminders/completed'
    | '/dashboard/inbox/reminders/create'
    | '/dashboard/teams/create/name'
    | '/dashboard/case/create'
    | '/dashboard/case/patient'
    | '/dashboard/case/progress-notes'
    | '/dashboard/case/records'
    | '/dashboard/case/referrals'
    | '/dashboard/chat/group'
    | '/dashboard/chat/single'
    | '/dashboard/contacts/contact'
    | '/dashboard/contacts/directory'
    | '/dashboard/inbox/alerts'
    | '/dashboard/inbox/reminders'
    | '/dashboard/teams/$id'
    | '/dashboard/teams/create'
    | '/dashboard/case/view/$id/case-info'
    | '/dashboard/case/view/$id/letter'
    | '/dashboard/accounts/settings/account/change-email'
    | '/dashboard/accounts/settings/account/change-password'
    | '/dashboard/accounts/settings/account/change-phone-number'
    | '/dashboard/accounts/settings/account/delete-account'
    | '/dashboard/accounts/settings/account/new-password'
    | '/dashboard/accounts/settings/account/verify-phone-number'
    | '/dashboard/accounts/settings/profile/credentials'
    | '/dashboard/accounts/settings/profile/information'
    | '/dashboard/calendar/events/$id/edit'
    | '/dashboard/case/create/exist/request-complete'
    | '/dashboard/case/view/$id/detail'
    | '/dashboard/case/view/$id/export'
    | '/dashboard/case/view/$id/search'
    | '/dashboard/chat/group/$id/$channelName'
    | '/dashboard/chat/group/$id/detail'
    | '/dashboard/chat/group/$id/edit'
    | '/dashboard/chat/group/$id/members'
    | '/dashboard/chat/single/$id/$channelName'
    | '/dashboard/teams/$id/edit/members'
    | '/dashboard/teams/$id/members/search'
    | '/dashboard/accounts/settings/account'
    | '/dashboard/accounts/settings/profile'
    | '/dashboard/case/create/exist'
    | '/dashboard/case/view/$id'
    | '/dashboard/chat/group/$id'
    | '/dashboard/chat/single/hemi'
    | '/dashboard/contacts/contact/teams'
    | '/dashboard/contacts/directory/teams'
    | '/dashboard/teams/$id/edit'
    | '/dashboard/case/create/exist/patient/$patientIc'
    | '/dashboard/case/create/exist/request/$caseId'
    | '/dashboard/case/view/$id/medical-note/create'
    | '/dashboard/case/view/$id/members/external'
    | '/dashboard/case/view/$id/patient-visits/create'
    | '/dashboard/case/view/$id/medical-note'
    | '/dashboard/case/view/$id/members'
    | '/dashboard/case/view/$id/patient-visits'
    | '/dashboard/case/view/$id/letter/$letterId/export'
    | '/dashboard/case/view/$id/letter/$letterId/update'
    | '/dashboard/case/view/$id/letter/new/info'
    | '/dashboard/case/view/$id/case-info/$type'
    | '/dashboard/case/view/$id/letter/$letterId'
    | '/dashboard/case/view/$id/letter/new'
  id:
    | '__root__'
    | '/'
    | '/create-account'
    | '/dashboard'
    | '/sso'
    | '/account'
    | '/cookie-policy'
    | '/delete-account-success'
    | '/download'
    | '/forgot-password'
    | '/manage-subscription'
    | '/new-password'
    | '/patient-policy'
    | '/payment-failed'
    | '/payment-success'
    | '/privacy-policy'
    | '/subscription-required'
    | '/success'
    | '/term-service'
    | '/verification'
    | '/dashboard/bulletin'
    | '/dashboard/calendar'
    | '/dashboard/camera'
    | '/dashboard/case'
    | '/dashboard/chat'
    | '/dashboard/contacts'
    | '/dashboard/inbox'
    | '/dashboard/teams'
    | '/create-account/cookie-credentials'
    | '/create-account/professional-credentials'
    | '/create-account/professional-profile'
    | '/create-account/verify-mobile'
    | '/sso/select-provider'
    | '/sso/signin'
    | '/subscription/$plan'
    | '/create-account/'
    | '/dashboard/'
    | '/subscription/'
    | '/dashboard/calendar/events'
    | '/dashboard/case/progress-notes'
    | '/dashboard/case/records'
    | '/dashboard/case/referrals'
    | '/dashboard/case/view'
    | '/dashboard/gallery/view'
    | '/dashboard/inbox/alerts'
    | '/dashboard/inbox/reminders'
    | '/dashboard/teams/$id'
    | '/dashboard/teams/create'
    | '/dashboard/bulletin/setting'
    | '/dashboard/case/$status'
    | '/dashboard/contacts/no-access'
    | '/dashboard/gallery/camera'
    | '/dashboard/gallery/exports'
    | '/dashboard/gallery/video'
    | '/dashboard/accounts/'
    | '/dashboard/bulletin/'
    | '/dashboard/calendar/'
    | '/dashboard/camera/'
    | '/dashboard/case/'
    | '/dashboard/contacts/'
    | '/dashboard/gallery/'
    | '/dashboard/inbox/'
    | '/dashboard/calendar/events/$id'
    | '/dashboard/case/view/$id'
    | '/dashboard/chat/group/$id'
    | '/dashboard/chat/single/$id'
    | '/dashboard/chat/single/hemi'
    | '/dashboard/teams/$id/edit'
    | '/dashboard/teams/$id/members'
    | '/dashboard/calendar/events/create'
    | '/dashboard/case/message/$id'
    | '/dashboard/case/progress-notes/closed'
    | '/dashboard/case/records/closed'
    | '/dashboard/case/referrals/contact'
    | '/dashboard/case/referrals/message'
    | '/dashboard/case/referrals/success'
    | '/dashboard/case/referrals/type'
    | '/dashboard/chat/group/create'
    | '/dashboard/chat/message/$id'
    | '/dashboard/chat/single/create'
    | '/dashboard/contacts/member/$id'
    | '/dashboard/gallery/view/$id'
    | '/dashboard/inbox/reminders/$id'
    | '/dashboard/inbox/reminders/completed'
    | '/dashboard/inbox/reminders/create'
    | '/dashboard/teams/create/name'
    | '/dashboard/case/create/'
    | '/dashboard/case/patient/'
    | '/dashboard/case/progress-notes/'
    | '/dashboard/case/records/'
    | '/dashboard/case/referrals/'
    | '/dashboard/chat/group/'
    | '/dashboard/chat/single/'
    | '/dashboard/contacts/contact/'
    | '/dashboard/contacts/directory/'
    | '/dashboard/inbox/alerts/'
    | '/dashboard/inbox/reminders/'
    | '/dashboard/teams/$id/'
    | '/dashboard/teams/create/'
    | '/dashboard/case/view/$id/case-info'
    | '/dashboard/case/view/$id/letter'
    | '/dashboard/case/view/$id/members'
    | '/dashboard/accounts/settings/account/change-email'
    | '/dashboard/accounts/settings/account/change-password'
    | '/dashboard/accounts/settings/account/change-phone-number'
    | '/dashboard/accounts/settings/account/delete-account'
    | '/dashboard/accounts/settings/account/new-password'
    | '/dashboard/accounts/settings/account/verify-phone-number'
    | '/dashboard/accounts/settings/profile/credentials'
    | '/dashboard/accounts/settings/profile/information'
    | '/dashboard/calendar/events/$id/edit'
    | '/dashboard/case/create/exist/request-complete'
    | '/dashboard/case/view/$id/detail'
    | '/dashboard/case/view/$id/export'
    | '/dashboard/case/view/$id/search'
    | '/dashboard/chat/group/$id/$channelName'
    | '/dashboard/chat/group/$id/detail'
    | '/dashboard/chat/group/$id/edit'
    | '/dashboard/chat/group/$id/members'
    | '/dashboard/chat/single/$id/$channelName'
    | '/dashboard/teams/$id/edit/members'
    | '/dashboard/teams/$id/members/search'
    | '/dashboard/accounts/settings/account/'
    | '/dashboard/accounts/settings/profile/'
    | '/dashboard/case/create/exist/'
    | '/dashboard/case/view/$id/'
    | '/dashboard/chat/group/$id/'
    | '/dashboard/chat/single/hemi/'
    | '/dashboard/contacts/contact/teams/'
    | '/dashboard/contacts/directory/teams/'
    | '/dashboard/teams/$id/edit/'
    | '/dashboard/case/view/$id/case-info/$type'
    | '/dashboard/case/view/$id/letter/$letterId'
    | '/dashboard/case/view/$id/letter/new'
    | '/dashboard/case/create/exist/patient/$patientIc'
    | '/dashboard/case/create/exist/request/$caseId'
    | '/dashboard/case/view/$id/medical-note/create'
    | '/dashboard/case/view/$id/members/external'
    | '/dashboard/case/view/$id/patient-visits/create'
    | '/dashboard/case/view/$id/medical-note/'
    | '/dashboard/case/view/$id/members/'
    | '/dashboard/case/view/$id/patient-visits/'
    | '/dashboard/case/view/$id/letter/$letterId/export'
    | '/dashboard/case/view/$id/letter/$letterId/update'
    | '/dashboard/case/view/$id/letter/new/info'
    | '/dashboard/case/view/$id/case-info/$type/'
    | '/dashboard/case/view/$id/letter/$letterId/'
    | '/dashboard/case/view/$id/letter/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CreateAccountRouteRoute: typeof CreateAccountRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  SsoRouteRoute: typeof SsoRouteRouteWithChildren
  AccountRoute: typeof AccountRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  DeleteAccountSuccessRoute: typeof DeleteAccountSuccessRoute
  DownloadRoute: typeof DownloadRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ManageSubscriptionRoute: typeof ManageSubscriptionRoute
  NewPasswordRoute: typeof NewPasswordRoute
  PatientPolicyRoute: typeof PatientPolicyRoute
  PaymentFailedRoute: typeof PaymentFailedRoute
  PaymentSuccessRoute: typeof PaymentSuccessRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SubscriptionRequiredRoute: typeof SubscriptionRequiredRoute
  SuccessRoute: typeof SuccessRoute
  TermServiceRoute: typeof TermServiceRoute
  VerificationRoute: typeof VerificationRoute
  SubscriptionPlanRoute: typeof SubscriptionPlanRoute
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verification': {
      id: '/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/term-service': {
      id: '/term-service'
      path: '/term-service'
      fullPath: '/term-service'
      preLoaderRoute: typeof TermServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/success': {
      id: '/success'
      path: '/success'
      fullPath: '/success'
      preLoaderRoute: typeof SuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription-required': {
      id: '/subscription-required'
      path: '/subscription-required'
      fullPath: '/subscription-required'
      preLoaderRoute: typeof SubscriptionRequiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-success': {
      id: '/payment-success'
      path: '/payment-success'
      fullPath: '/payment-success'
      preLoaderRoute: typeof PaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-failed': {
      id: '/payment-failed'
      path: '/payment-failed'
      fullPath: '/payment-failed'
      preLoaderRoute: typeof PaymentFailedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patient-policy': {
      id: '/patient-policy'
      path: '/patient-policy'
      fullPath: '/patient-policy'
      preLoaderRoute: typeof PatientPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-password': {
      id: '/new-password'
      path: '/new-password'
      fullPath: '/new-password'
      preLoaderRoute: typeof NewPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage-subscription': {
      id: '/manage-subscription'
      path: '/manage-subscription'
      fullPath: '/manage-subscription'
      preLoaderRoute: typeof ManageSubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account-success': {
      id: '/delete-account-success'
      path: '/delete-account-success'
      fullPath: '/delete-account-success'
      preLoaderRoute: typeof DeleteAccountSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/create-account/': {
      id: '/create-account/'
      path: '/'
      fullPath: '/create-account/'
      preLoaderRoute: typeof CreateAccountIndexRouteImport
      parentRoute: typeof CreateAccountRouteRoute
    }
    '/subscription/$plan': {
      id: '/subscription/$plan'
      path: '/subscription/$plan'
      fullPath: '/subscription/$plan'
      preLoaderRoute: typeof SubscriptionPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/signin': {
      id: '/sso/signin'
      path: '/signin'
      fullPath: '/sso/signin'
      preLoaderRoute: typeof SsoSigninRouteImport
      parentRoute: typeof SsoRouteRoute
    }
    '/sso/select-provider': {
      id: '/sso/select-provider'
      path: '/select-provider'
      fullPath: '/sso/select-provider'
      preLoaderRoute: typeof SsoSelectProviderRouteImport
      parentRoute: typeof SsoRouteRoute
    }
    '/create-account/verify-mobile': {
      id: '/create-account/verify-mobile'
      path: '/verify-mobile'
      fullPath: '/create-account/verify-mobile'
      preLoaderRoute: typeof CreateAccountVerifyMobileRouteImport
      parentRoute: typeof CreateAccountRouteRoute
    }
    '/create-account/professional-profile': {
      id: '/create-account/professional-profile'
      path: '/professional-profile'
      fullPath: '/create-account/professional-profile'
      preLoaderRoute: typeof CreateAccountProfessionalProfileRouteImport
      parentRoute: typeof CreateAccountRouteRoute
    }
    '/create-account/professional-credentials': {
      id: '/create-account/professional-credentials'
      path: '/professional-credentials'
      fullPath: '/create-account/professional-credentials'
      preLoaderRoute: typeof CreateAccountProfessionalCredentialsRouteImport
      parentRoute: typeof CreateAccountRouteRoute
    }
    '/create-account/cookie-credentials': {
      id: '/create-account/cookie-credentials'
      path: '/cookie-credentials'
      fullPath: '/create-account/cookie-credentials'
      preLoaderRoute: typeof CreateAccountCookieCredentialsRouteImport
      parentRoute: typeof CreateAccountRouteRoute
    }
    '/dashboard/teams': {
      id: '/dashboard/teams'
      path: '/teams'
      fullPath: '/dashboard/teams'
      preLoaderRoute: typeof DashboardTeamsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/inbox': {
      id: '/dashboard/inbox'
      path: '/inbox'
      fullPath: '/dashboard/inbox'
      preLoaderRoute: typeof DashboardInboxRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/contacts': {
      id: '/dashboard/contacts'
      path: '/contacts'
      fullPath: '/dashboard/contacts'
      preLoaderRoute: typeof DashboardContactsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/chat': {
      id: '/dashboard/chat'
      path: '/chat'
      fullPath: '/dashboard/chat'
      preLoaderRoute: typeof DashboardChatRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/case': {
      id: '/dashboard/case'
      path: '/case'
      fullPath: '/dashboard/case'
      preLoaderRoute: typeof DashboardCaseRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/camera': {
      id: '/dashboard/camera'
      path: '/camera'
      fullPath: '/dashboard/camera'
      preLoaderRoute: typeof DashboardCameraRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/bulletin': {
      id: '/dashboard/bulletin'
      path: '/bulletin'
      fullPath: '/dashboard/bulletin'
      preLoaderRoute: typeof DashboardBulletinRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/inbox/': {
      id: '/dashboard/inbox/'
      path: '/'
      fullPath: '/dashboard/inbox/'
      preLoaderRoute: typeof DashboardInboxIndexRouteImport
      parentRoute: typeof DashboardInboxRouteRoute
    }
    '/dashboard/gallery/': {
      id: '/dashboard/gallery/'
      path: '/gallery'
      fullPath: '/dashboard/gallery'
      preLoaderRoute: typeof DashboardGalleryIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/contacts/': {
      id: '/dashboard/contacts/'
      path: '/'
      fullPath: '/dashboard/contacts/'
      preLoaderRoute: typeof DashboardContactsIndexRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/case/': {
      id: '/dashboard/case/'
      path: '/'
      fullPath: '/dashboard/case/'
      preLoaderRoute: typeof DashboardCaseIndexRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/camera/': {
      id: '/dashboard/camera/'
      path: '/'
      fullPath: '/dashboard/camera/'
      preLoaderRoute: typeof DashboardCameraIndexRouteImport
      parentRoute: typeof DashboardCameraRouteRoute
    }
    '/dashboard/calendar/': {
      id: '/dashboard/calendar/'
      path: '/'
      fullPath: '/dashboard/calendar/'
      preLoaderRoute: typeof DashboardCalendarIndexRouteImport
      parentRoute: typeof DashboardCalendarRouteRoute
    }
    '/dashboard/bulletin/': {
      id: '/dashboard/bulletin/'
      path: '/'
      fullPath: '/dashboard/bulletin/'
      preLoaderRoute: typeof DashboardBulletinIndexRouteImport
      parentRoute: typeof DashboardBulletinRouteRoute
    }
    '/dashboard/accounts/': {
      id: '/dashboard/accounts/'
      path: '/accounts'
      fullPath: '/dashboard/accounts'
      preLoaderRoute: typeof DashboardAccountsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/gallery/video': {
      id: '/dashboard/gallery/video'
      path: '/gallery/video'
      fullPath: '/dashboard/gallery/video'
      preLoaderRoute: typeof DashboardGalleryVideoRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/gallery/exports': {
      id: '/dashboard/gallery/exports'
      path: '/gallery/exports'
      fullPath: '/dashboard/gallery/exports'
      preLoaderRoute: typeof DashboardGalleryExportsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/gallery/camera': {
      id: '/dashboard/gallery/camera'
      path: '/gallery/camera'
      fullPath: '/dashboard/gallery/camera'
      preLoaderRoute: typeof DashboardGalleryCameraRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/contacts/no-access': {
      id: '/dashboard/contacts/no-access'
      path: '/no-access'
      fullPath: '/dashboard/contacts/no-access'
      preLoaderRoute: typeof DashboardContactsNoAccessRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/case/$status': {
      id: '/dashboard/case/$status'
      path: '/$status'
      fullPath: '/dashboard/case/$status'
      preLoaderRoute: typeof DashboardCaseStatusRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/bulletin/setting': {
      id: '/dashboard/bulletin/setting'
      path: '/setting'
      fullPath: '/dashboard/bulletin/setting'
      preLoaderRoute: typeof DashboardBulletinSettingRouteImport
      parentRoute: typeof DashboardBulletinRouteRoute
    }
    '/dashboard/teams/create': {
      id: '/dashboard/teams/create'
      path: '/create'
      fullPath: '/dashboard/teams/create'
      preLoaderRoute: typeof DashboardTeamsCreateRouteRouteImport
      parentRoute: typeof DashboardTeamsRouteRoute
    }
    '/dashboard/teams/$id': {
      id: '/dashboard/teams/$id'
      path: '/$id'
      fullPath: '/dashboard/teams/$id'
      preLoaderRoute: typeof DashboardTeamsIdRouteRouteImport
      parentRoute: typeof DashboardTeamsRouteRoute
    }
    '/dashboard/inbox/reminders': {
      id: '/dashboard/inbox/reminders'
      path: '/reminders'
      fullPath: '/dashboard/inbox/reminders'
      preLoaderRoute: typeof DashboardInboxRemindersRouteRouteImport
      parentRoute: typeof DashboardInboxRouteRoute
    }
    '/dashboard/inbox/alerts': {
      id: '/dashboard/inbox/alerts'
      path: '/alerts'
      fullPath: '/dashboard/inbox/alerts'
      preLoaderRoute: typeof DashboardInboxAlertsRouteRouteImport
      parentRoute: typeof DashboardInboxRouteRoute
    }
    '/dashboard/gallery/view': {
      id: '/dashboard/gallery/view'
      path: '/gallery/view'
      fullPath: '/dashboard/gallery/view'
      preLoaderRoute: typeof DashboardGalleryViewRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/case/view': {
      id: '/dashboard/case/view'
      path: '/view'
      fullPath: '/dashboard/case/view'
      preLoaderRoute: typeof DashboardCaseViewRouteRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/referrals': {
      id: '/dashboard/case/referrals'
      path: '/referrals'
      fullPath: '/dashboard/case/referrals'
      preLoaderRoute: typeof DashboardCaseReferralsRouteRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/records': {
      id: '/dashboard/case/records'
      path: '/records'
      fullPath: '/dashboard/case/records'
      preLoaderRoute: typeof DashboardCaseRecordsRouteRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/progress-notes': {
      id: '/dashboard/case/progress-notes'
      path: '/progress-notes'
      fullPath: '/dashboard/case/progress-notes'
      preLoaderRoute: typeof DashboardCaseProgressNotesRouteRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/calendar/events': {
      id: '/dashboard/calendar/events'
      path: '/events'
      fullPath: '/dashboard/calendar/events'
      preLoaderRoute: typeof DashboardCalendarEventsRouteRouteImport
      parentRoute: typeof DashboardCalendarRouteRoute
    }
    '/dashboard/teams/create/': {
      id: '/dashboard/teams/create/'
      path: '/'
      fullPath: '/dashboard/teams/create/'
      preLoaderRoute: typeof DashboardTeamsCreateIndexRouteImport
      parentRoute: typeof DashboardTeamsCreateRouteRoute
    }
    '/dashboard/teams/$id/': {
      id: '/dashboard/teams/$id/'
      path: '/'
      fullPath: '/dashboard/teams/$id/'
      preLoaderRoute: typeof DashboardTeamsIdIndexRouteImport
      parentRoute: typeof DashboardTeamsIdRouteRoute
    }
    '/dashboard/inbox/reminders/': {
      id: '/dashboard/inbox/reminders/'
      path: '/'
      fullPath: '/dashboard/inbox/reminders/'
      preLoaderRoute: typeof DashboardInboxRemindersIndexRouteImport
      parentRoute: typeof DashboardInboxRemindersRouteRoute
    }
    '/dashboard/inbox/alerts/': {
      id: '/dashboard/inbox/alerts/'
      path: '/'
      fullPath: '/dashboard/inbox/alerts/'
      preLoaderRoute: typeof DashboardInboxAlertsIndexRouteImport
      parentRoute: typeof DashboardInboxAlertsRouteRoute
    }
    '/dashboard/contacts/directory/': {
      id: '/dashboard/contacts/directory/'
      path: '/directory'
      fullPath: '/dashboard/contacts/directory'
      preLoaderRoute: typeof DashboardContactsDirectoryIndexRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/contacts/contact/': {
      id: '/dashboard/contacts/contact/'
      path: '/contact'
      fullPath: '/dashboard/contacts/contact'
      preLoaderRoute: typeof DashboardContactsContactIndexRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/chat/single/': {
      id: '/dashboard/chat/single/'
      path: '/single'
      fullPath: '/dashboard/chat/single'
      preLoaderRoute: typeof DashboardChatSingleIndexRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/chat/group/': {
      id: '/dashboard/chat/group/'
      path: '/group'
      fullPath: '/dashboard/chat/group'
      preLoaderRoute: typeof DashboardChatGroupIndexRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/case/referrals/': {
      id: '/dashboard/case/referrals/'
      path: '/'
      fullPath: '/dashboard/case/referrals/'
      preLoaderRoute: typeof DashboardCaseReferralsIndexRouteImport
      parentRoute: typeof DashboardCaseReferralsRouteRoute
    }
    '/dashboard/case/records/': {
      id: '/dashboard/case/records/'
      path: '/'
      fullPath: '/dashboard/case/records/'
      preLoaderRoute: typeof DashboardCaseRecordsIndexRouteImport
      parentRoute: typeof DashboardCaseRecordsRouteRoute
    }
    '/dashboard/case/progress-notes/': {
      id: '/dashboard/case/progress-notes/'
      path: '/'
      fullPath: '/dashboard/case/progress-notes/'
      preLoaderRoute: typeof DashboardCaseProgressNotesIndexRouteImport
      parentRoute: typeof DashboardCaseProgressNotesRouteRoute
    }
    '/dashboard/case/patient/': {
      id: '/dashboard/case/patient/'
      path: '/patient'
      fullPath: '/dashboard/case/patient'
      preLoaderRoute: typeof DashboardCasePatientIndexRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/create/': {
      id: '/dashboard/case/create/'
      path: '/create'
      fullPath: '/dashboard/case/create'
      preLoaderRoute: typeof DashboardCaseCreateIndexRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/teams/create/name': {
      id: '/dashboard/teams/create/name'
      path: '/name'
      fullPath: '/dashboard/teams/create/name'
      preLoaderRoute: typeof DashboardTeamsCreateNameRouteImport
      parentRoute: typeof DashboardTeamsCreateRouteRoute
    }
    '/dashboard/inbox/reminders/create': {
      id: '/dashboard/inbox/reminders/create'
      path: '/create'
      fullPath: '/dashboard/inbox/reminders/create'
      preLoaderRoute: typeof DashboardInboxRemindersCreateRouteImport
      parentRoute: typeof DashboardInboxRemindersRouteRoute
    }
    '/dashboard/inbox/reminders/completed': {
      id: '/dashboard/inbox/reminders/completed'
      path: '/completed'
      fullPath: '/dashboard/inbox/reminders/completed'
      preLoaderRoute: typeof DashboardInboxRemindersCompletedRouteImport
      parentRoute: typeof DashboardInboxRemindersRouteRoute
    }
    '/dashboard/inbox/reminders/$id': {
      id: '/dashboard/inbox/reminders/$id'
      path: '/$id'
      fullPath: '/dashboard/inbox/reminders/$id'
      preLoaderRoute: typeof DashboardInboxRemindersIdRouteImport
      parentRoute: typeof DashboardInboxRemindersRouteRoute
    }
    '/dashboard/gallery/view/$id': {
      id: '/dashboard/gallery/view/$id'
      path: '/$id'
      fullPath: '/dashboard/gallery/view/$id'
      preLoaderRoute: typeof DashboardGalleryViewIdRouteImport
      parentRoute: typeof DashboardGalleryViewRouteRoute
    }
    '/dashboard/contacts/member/$id': {
      id: '/dashboard/contacts/member/$id'
      path: '/member/$id'
      fullPath: '/dashboard/contacts/member/$id'
      preLoaderRoute: typeof DashboardContactsMemberIdRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/chat/single/create': {
      id: '/dashboard/chat/single/create'
      path: '/single/create'
      fullPath: '/dashboard/chat/single/create'
      preLoaderRoute: typeof DashboardChatSingleCreateRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/chat/message/$id': {
      id: '/dashboard/chat/message/$id'
      path: '/message/$id'
      fullPath: '/dashboard/chat/message/$id'
      preLoaderRoute: typeof DashboardChatMessageIdRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/chat/group/create': {
      id: '/dashboard/chat/group/create'
      path: '/group/create'
      fullPath: '/dashboard/chat/group/create'
      preLoaderRoute: typeof DashboardChatGroupCreateRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/case/referrals/type': {
      id: '/dashboard/case/referrals/type'
      path: '/type'
      fullPath: '/dashboard/case/referrals/type'
      preLoaderRoute: typeof DashboardCaseReferralsTypeRouteImport
      parentRoute: typeof DashboardCaseReferralsRouteRoute
    }
    '/dashboard/case/referrals/success': {
      id: '/dashboard/case/referrals/success'
      path: '/success'
      fullPath: '/dashboard/case/referrals/success'
      preLoaderRoute: typeof DashboardCaseReferralsSuccessRouteImport
      parentRoute: typeof DashboardCaseReferralsRouteRoute
    }
    '/dashboard/case/referrals/message': {
      id: '/dashboard/case/referrals/message'
      path: '/message'
      fullPath: '/dashboard/case/referrals/message'
      preLoaderRoute: typeof DashboardCaseReferralsMessageRouteImport
      parentRoute: typeof DashboardCaseReferralsRouteRoute
    }
    '/dashboard/case/referrals/contact': {
      id: '/dashboard/case/referrals/contact'
      path: '/contact'
      fullPath: '/dashboard/case/referrals/contact'
      preLoaderRoute: typeof DashboardCaseReferralsContactRouteImport
      parentRoute: typeof DashboardCaseReferralsRouteRoute
    }
    '/dashboard/case/records/closed': {
      id: '/dashboard/case/records/closed'
      path: '/closed'
      fullPath: '/dashboard/case/records/closed'
      preLoaderRoute: typeof DashboardCaseRecordsClosedRouteImport
      parentRoute: typeof DashboardCaseRecordsRouteRoute
    }
    '/dashboard/case/progress-notes/closed': {
      id: '/dashboard/case/progress-notes/closed'
      path: '/closed'
      fullPath: '/dashboard/case/progress-notes/closed'
      preLoaderRoute: typeof DashboardCaseProgressNotesClosedRouteImport
      parentRoute: typeof DashboardCaseProgressNotesRouteRoute
    }
    '/dashboard/case/message/$id': {
      id: '/dashboard/case/message/$id'
      path: '/message/$id'
      fullPath: '/dashboard/case/message/$id'
      preLoaderRoute: typeof DashboardCaseMessageIdRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/calendar/events/create': {
      id: '/dashboard/calendar/events/create'
      path: '/create'
      fullPath: '/dashboard/calendar/events/create'
      preLoaderRoute: typeof DashboardCalendarEventsCreateRouteImport
      parentRoute: typeof DashboardCalendarEventsRouteRoute
    }
    '/dashboard/teams/$id/members': {
      id: '/dashboard/teams/$id/members'
      path: '/members'
      fullPath: '/dashboard/teams/$id/members'
      preLoaderRoute: typeof DashboardTeamsIdMembersRouteRouteImport
      parentRoute: typeof DashboardTeamsIdRouteRoute
    }
    '/dashboard/teams/$id/edit': {
      id: '/dashboard/teams/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/teams/$id/edit'
      preLoaderRoute: typeof DashboardTeamsIdEditRouteRouteImport
      parentRoute: typeof DashboardTeamsIdRouteRoute
    }
    '/dashboard/chat/single/hemi': {
      id: '/dashboard/chat/single/hemi'
      path: '/single/hemi'
      fullPath: '/dashboard/chat/single/hemi'
      preLoaderRoute: typeof DashboardChatSingleHemiRouteRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/chat/single/$id': {
      id: '/dashboard/chat/single/$id'
      path: '/single/$id'
      fullPath: '/dashboard/chat/single/$id'
      preLoaderRoute: typeof DashboardChatSingleIdRouteRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/chat/group/$id': {
      id: '/dashboard/chat/group/$id'
      path: '/group/$id'
      fullPath: '/dashboard/chat/group/$id'
      preLoaderRoute: typeof DashboardChatGroupIdRouteRouteImport
      parentRoute: typeof DashboardChatRouteRoute
    }
    '/dashboard/case/view/$id': {
      id: '/dashboard/case/view/$id'
      path: '/$id'
      fullPath: '/dashboard/case/view/$id'
      preLoaderRoute: typeof DashboardCaseViewIdRouteRouteImport
      parentRoute: typeof DashboardCaseViewRouteRoute
    }
    '/dashboard/calendar/events/$id': {
      id: '/dashboard/calendar/events/$id'
      path: '/$id'
      fullPath: '/dashboard/calendar/events/$id'
      preLoaderRoute: typeof DashboardCalendarEventsIdRouteRouteImport
      parentRoute: typeof DashboardCalendarEventsRouteRoute
    }
    '/dashboard/teams/$id/edit/': {
      id: '/dashboard/teams/$id/edit/'
      path: '/'
      fullPath: '/dashboard/teams/$id/edit/'
      preLoaderRoute: typeof DashboardTeamsIdEditIndexRouteImport
      parentRoute: typeof DashboardTeamsIdEditRouteRoute
    }
    '/dashboard/contacts/directory/teams/': {
      id: '/dashboard/contacts/directory/teams/'
      path: '/directory/teams'
      fullPath: '/dashboard/contacts/directory/teams'
      preLoaderRoute: typeof DashboardContactsDirectoryTeamsIndexRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/contacts/contact/teams/': {
      id: '/dashboard/contacts/contact/teams/'
      path: '/contact/teams'
      fullPath: '/dashboard/contacts/contact/teams'
      preLoaderRoute: typeof DashboardContactsContactTeamsIndexRouteImport
      parentRoute: typeof DashboardContactsRouteRoute
    }
    '/dashboard/chat/single/hemi/': {
      id: '/dashboard/chat/single/hemi/'
      path: '/'
      fullPath: '/dashboard/chat/single/hemi/'
      preLoaderRoute: typeof DashboardChatSingleHemiIndexRouteImport
      parentRoute: typeof DashboardChatSingleHemiRouteRoute
    }
    '/dashboard/chat/group/$id/': {
      id: '/dashboard/chat/group/$id/'
      path: '/'
      fullPath: '/dashboard/chat/group/$id/'
      preLoaderRoute: typeof DashboardChatGroupIdIndexRouteImport
      parentRoute: typeof DashboardChatGroupIdRouteRoute
    }
    '/dashboard/case/view/$id/': {
      id: '/dashboard/case/view/$id/'
      path: '/'
      fullPath: '/dashboard/case/view/$id/'
      preLoaderRoute: typeof DashboardCaseViewIdIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/create/exist/': {
      id: '/dashboard/case/create/exist/'
      path: '/create/exist'
      fullPath: '/dashboard/case/create/exist'
      preLoaderRoute: typeof DashboardCaseCreateExistIndexRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/accounts/settings/profile/': {
      id: '/dashboard/accounts/settings/profile/'
      path: '/accounts/settings/profile'
      fullPath: '/dashboard/accounts/settings/profile'
      preLoaderRoute: typeof DashboardAccountsSettingsProfileIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/': {
      id: '/dashboard/accounts/settings/account/'
      path: '/accounts/settings/account'
      fullPath: '/dashboard/accounts/settings/account'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/teams/$id/members/search': {
      id: '/dashboard/teams/$id/members/search'
      path: '/search'
      fullPath: '/dashboard/teams/$id/members/search'
      preLoaderRoute: typeof DashboardTeamsIdMembersSearchRouteImport
      parentRoute: typeof DashboardTeamsIdMembersRouteRoute
    }
    '/dashboard/teams/$id/edit/members': {
      id: '/dashboard/teams/$id/edit/members'
      path: '/members'
      fullPath: '/dashboard/teams/$id/edit/members'
      preLoaderRoute: typeof DashboardTeamsIdEditMembersRouteImport
      parentRoute: typeof DashboardTeamsIdEditRouteRoute
    }
    '/dashboard/chat/single/$id/$channelName': {
      id: '/dashboard/chat/single/$id/$channelName'
      path: '/$channelName'
      fullPath: '/dashboard/chat/single/$id/$channelName'
      preLoaderRoute: typeof DashboardChatSingleIdChannelNameRouteImport
      parentRoute: typeof DashboardChatSingleIdRouteRoute
    }
    '/dashboard/chat/group/$id/members': {
      id: '/dashboard/chat/group/$id/members'
      path: '/members'
      fullPath: '/dashboard/chat/group/$id/members'
      preLoaderRoute: typeof DashboardChatGroupIdMembersRouteImport
      parentRoute: typeof DashboardChatGroupIdRouteRoute
    }
    '/dashboard/chat/group/$id/edit': {
      id: '/dashboard/chat/group/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/chat/group/$id/edit'
      preLoaderRoute: typeof DashboardChatGroupIdEditRouteImport
      parentRoute: typeof DashboardChatGroupIdRouteRoute
    }
    '/dashboard/chat/group/$id/detail': {
      id: '/dashboard/chat/group/$id/detail'
      path: '/detail'
      fullPath: '/dashboard/chat/group/$id/detail'
      preLoaderRoute: typeof DashboardChatGroupIdDetailRouteImport
      parentRoute: typeof DashboardChatGroupIdRouteRoute
    }
    '/dashboard/chat/group/$id/$channelName': {
      id: '/dashboard/chat/group/$id/$channelName'
      path: '/$channelName'
      fullPath: '/dashboard/chat/group/$id/$channelName'
      preLoaderRoute: typeof DashboardChatGroupIdChannelNameRouteImport
      parentRoute: typeof DashboardChatGroupIdRouteRoute
    }
    '/dashboard/case/view/$id/search': {
      id: '/dashboard/case/view/$id/search'
      path: '/search'
      fullPath: '/dashboard/case/view/$id/search'
      preLoaderRoute: typeof DashboardCaseViewIdSearchRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/export': {
      id: '/dashboard/case/view/$id/export'
      path: '/export'
      fullPath: '/dashboard/case/view/$id/export'
      preLoaderRoute: typeof DashboardCaseViewIdExportRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/detail': {
      id: '/dashboard/case/view/$id/detail'
      path: '/detail'
      fullPath: '/dashboard/case/view/$id/detail'
      preLoaderRoute: typeof DashboardCaseViewIdDetailRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/create/exist/request-complete': {
      id: '/dashboard/case/create/exist/request-complete'
      path: '/create/exist/request-complete'
      fullPath: '/dashboard/case/create/exist/request-complete'
      preLoaderRoute: typeof DashboardCaseCreateExistRequestCompleteRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/calendar/events/$id/edit': {
      id: '/dashboard/calendar/events/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/calendar/events/$id/edit'
      preLoaderRoute: typeof DashboardCalendarEventsIdEditRouteImport
      parentRoute: typeof DashboardCalendarEventsIdRouteRoute
    }
    '/dashboard/accounts/settings/profile/information': {
      id: '/dashboard/accounts/settings/profile/information'
      path: '/accounts/settings/profile/information'
      fullPath: '/dashboard/accounts/settings/profile/information'
      preLoaderRoute: typeof DashboardAccountsSettingsProfileInformationRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/profile/credentials': {
      id: '/dashboard/accounts/settings/profile/credentials'
      path: '/accounts/settings/profile/credentials'
      fullPath: '/dashboard/accounts/settings/profile/credentials'
      preLoaderRoute: typeof DashboardAccountsSettingsProfileCredentialsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/verify-phone-number': {
      id: '/dashboard/accounts/settings/account/verify-phone-number'
      path: '/accounts/settings/account/verify-phone-number'
      fullPath: '/dashboard/accounts/settings/account/verify-phone-number'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountVerifyPhoneNumberRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/new-password': {
      id: '/dashboard/accounts/settings/account/new-password'
      path: '/accounts/settings/account/new-password'
      fullPath: '/dashboard/accounts/settings/account/new-password'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountNewPasswordRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/delete-account': {
      id: '/dashboard/accounts/settings/account/delete-account'
      path: '/accounts/settings/account/delete-account'
      fullPath: '/dashboard/accounts/settings/account/delete-account'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountDeleteAccountRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/change-phone-number': {
      id: '/dashboard/accounts/settings/account/change-phone-number'
      path: '/accounts/settings/account/change-phone-number'
      fullPath: '/dashboard/accounts/settings/account/change-phone-number'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountChangePhoneNumberRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/change-password': {
      id: '/dashboard/accounts/settings/account/change-password'
      path: '/accounts/settings/account/change-password'
      fullPath: '/dashboard/accounts/settings/account/change-password'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountChangePasswordRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/accounts/settings/account/change-email': {
      id: '/dashboard/accounts/settings/account/change-email'
      path: '/accounts/settings/account/change-email'
      fullPath: '/dashboard/accounts/settings/account/change-email'
      preLoaderRoute: typeof DashboardAccountsSettingsAccountChangeEmailRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/case/view/$id/members': {
      id: '/dashboard/case/view/$id/members'
      path: '/members'
      fullPath: '/dashboard/case/view/$id/members'
      preLoaderRoute: typeof DashboardCaseViewIdMembersRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/letter': {
      id: '/dashboard/case/view/$id/letter'
      path: '/letter'
      fullPath: '/dashboard/case/view/$id/letter'
      preLoaderRoute: typeof DashboardCaseViewIdLetterRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/case-info': {
      id: '/dashboard/case/view/$id/case-info'
      path: '/case-info'
      fullPath: '/dashboard/case/view/$id/case-info'
      preLoaderRoute: typeof DashboardCaseViewIdCaseInfoRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/patient-visits/': {
      id: '/dashboard/case/view/$id/patient-visits/'
      path: '/patient-visits'
      fullPath: '/dashboard/case/view/$id/patient-visits'
      preLoaderRoute: typeof DashboardCaseViewIdPatientVisitsIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/members/': {
      id: '/dashboard/case/view/$id/members/'
      path: '/'
      fullPath: '/dashboard/case/view/$id/members/'
      preLoaderRoute: typeof DashboardCaseViewIdMembersIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdMembersRouteRoute
    }
    '/dashboard/case/view/$id/medical-note/': {
      id: '/dashboard/case/view/$id/medical-note/'
      path: '/medical-note'
      fullPath: '/dashboard/case/view/$id/medical-note'
      preLoaderRoute: typeof DashboardCaseViewIdMedicalNoteIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/patient-visits/create': {
      id: '/dashboard/case/view/$id/patient-visits/create'
      path: '/patient-visits/create'
      fullPath: '/dashboard/case/view/$id/patient-visits/create'
      preLoaderRoute: typeof DashboardCaseViewIdPatientVisitsCreateRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/view/$id/members/external': {
      id: '/dashboard/case/view/$id/members/external'
      path: '/external'
      fullPath: '/dashboard/case/view/$id/members/external'
      preLoaderRoute: typeof DashboardCaseViewIdMembersExternalRouteImport
      parentRoute: typeof DashboardCaseViewIdMembersRouteRoute
    }
    '/dashboard/case/view/$id/medical-note/create': {
      id: '/dashboard/case/view/$id/medical-note/create'
      path: '/medical-note/create'
      fullPath: '/dashboard/case/view/$id/medical-note/create'
      preLoaderRoute: typeof DashboardCaseViewIdMedicalNoteCreateRouteImport
      parentRoute: typeof DashboardCaseViewIdRouteRoute
    }
    '/dashboard/case/create/exist/request/$caseId': {
      id: '/dashboard/case/create/exist/request/$caseId'
      path: '/create/exist/request/$caseId'
      fullPath: '/dashboard/case/create/exist/request/$caseId'
      preLoaderRoute: typeof DashboardCaseCreateExistRequestCaseIdRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/create/exist/patient/$patientIc': {
      id: '/dashboard/case/create/exist/patient/$patientIc'
      path: '/create/exist/patient/$patientIc'
      fullPath: '/dashboard/case/create/exist/patient/$patientIc'
      preLoaderRoute: typeof DashboardCaseCreateExistPatientPatientIcRouteImport
      parentRoute: typeof DashboardCaseRouteRoute
    }
    '/dashboard/case/view/$id/letter/new': {
      id: '/dashboard/case/view/$id/letter/new'
      path: '/new'
      fullPath: '/dashboard/case/view/$id/letter/new'
      preLoaderRoute: typeof DashboardCaseViewIdLetterNewRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterRouteRoute
    }
    '/dashboard/case/view/$id/letter/$letterId': {
      id: '/dashboard/case/view/$id/letter/$letterId'
      path: '/$letterId'
      fullPath: '/dashboard/case/view/$id/letter/$letterId'
      preLoaderRoute: typeof DashboardCaseViewIdLetterLetterIdRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterRouteRoute
    }
    '/dashboard/case/view/$id/case-info/$type': {
      id: '/dashboard/case/view/$id/case-info/$type'
      path: '/$type'
      fullPath: '/dashboard/case/view/$id/case-info/$type'
      preLoaderRoute: typeof DashboardCaseViewIdCaseInfoTypeRouteRouteImport
      parentRoute: typeof DashboardCaseViewIdCaseInfoRouteRoute
    }
    '/dashboard/case/view/$id/letter/new/': {
      id: '/dashboard/case/view/$id/letter/new/'
      path: '/'
      fullPath: '/dashboard/case/view/$id/letter/new/'
      preLoaderRoute: typeof DashboardCaseViewIdLetterNewIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterNewRouteRoute
    }
    '/dashboard/case/view/$id/letter/$letterId/': {
      id: '/dashboard/case/view/$id/letter/$letterId/'
      path: '/'
      fullPath: '/dashboard/case/view/$id/letter/$letterId/'
      preLoaderRoute: typeof DashboardCaseViewIdLetterLetterIdIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterLetterIdRouteRoute
    }
    '/dashboard/case/view/$id/case-info/$type/': {
      id: '/dashboard/case/view/$id/case-info/$type/'
      path: '/'
      fullPath: '/dashboard/case/view/$id/case-info/$type/'
      preLoaderRoute: typeof DashboardCaseViewIdCaseInfoTypeIndexRouteImport
      parentRoute: typeof DashboardCaseViewIdCaseInfoTypeRouteRoute
    }
    '/dashboard/case/view/$id/letter/new/info': {
      id: '/dashboard/case/view/$id/letter/new/info'
      path: '/info'
      fullPath: '/dashboard/case/view/$id/letter/new/info'
      preLoaderRoute: typeof DashboardCaseViewIdLetterNewInfoRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterNewRouteRoute
    }
    '/dashboard/case/view/$id/letter/$letterId/update': {
      id: '/dashboard/case/view/$id/letter/$letterId/update'
      path: '/update'
      fullPath: '/dashboard/case/view/$id/letter/$letterId/update'
      preLoaderRoute: typeof DashboardCaseViewIdLetterLetterIdUpdateRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterLetterIdRouteRoute
    }
    '/dashboard/case/view/$id/letter/$letterId/export': {
      id: '/dashboard/case/view/$id/letter/$letterId/export'
      path: '/export'
      fullPath: '/dashboard/case/view/$id/letter/$letterId/export'
      preLoaderRoute: typeof DashboardCaseViewIdLetterLetterIdExportRouteImport
      parentRoute: typeof DashboardCaseViewIdLetterLetterIdRouteRoute
    }
  }
}

interface CreateAccountRouteRouteChildren {
  CreateAccountCookieCredentialsRoute: typeof CreateAccountCookieCredentialsRoute
  CreateAccountProfessionalCredentialsRoute: typeof CreateAccountProfessionalCredentialsRoute
  CreateAccountProfessionalProfileRoute: typeof CreateAccountProfessionalProfileRoute
  CreateAccountVerifyMobileRoute: typeof CreateAccountVerifyMobileRoute
  CreateAccountIndexRoute: typeof CreateAccountIndexRoute
}

const CreateAccountRouteRouteChildren: CreateAccountRouteRouteChildren = {
  CreateAccountCookieCredentialsRoute: CreateAccountCookieCredentialsRoute,
  CreateAccountProfessionalCredentialsRoute:
    CreateAccountProfessionalCredentialsRoute,
  CreateAccountProfessionalProfileRoute: CreateAccountProfessionalProfileRoute,
  CreateAccountVerifyMobileRoute: CreateAccountVerifyMobileRoute,
  CreateAccountIndexRoute: CreateAccountIndexRoute,
}

const CreateAccountRouteRouteWithChildren =
  CreateAccountRouteRoute._addFileChildren(CreateAccountRouteRouteChildren)

interface DashboardBulletinRouteRouteChildren {
  DashboardBulletinSettingRoute: typeof DashboardBulletinSettingRoute
  DashboardBulletinIndexRoute: typeof DashboardBulletinIndexRoute
}

const DashboardBulletinRouteRouteChildren: DashboardBulletinRouteRouteChildren =
  {
    DashboardBulletinSettingRoute: DashboardBulletinSettingRoute,
    DashboardBulletinIndexRoute: DashboardBulletinIndexRoute,
  }

const DashboardBulletinRouteRouteWithChildren =
  DashboardBulletinRouteRoute._addFileChildren(
    DashboardBulletinRouteRouteChildren,
  )

interface DashboardCalendarEventsIdRouteRouteChildren {
  DashboardCalendarEventsIdEditRoute: typeof DashboardCalendarEventsIdEditRoute
}

const DashboardCalendarEventsIdRouteRouteChildren: DashboardCalendarEventsIdRouteRouteChildren =
  {
    DashboardCalendarEventsIdEditRoute: DashboardCalendarEventsIdEditRoute,
  }

const DashboardCalendarEventsIdRouteRouteWithChildren =
  DashboardCalendarEventsIdRouteRoute._addFileChildren(
    DashboardCalendarEventsIdRouteRouteChildren,
  )

interface DashboardCalendarEventsRouteRouteChildren {
  DashboardCalendarEventsIdRouteRoute: typeof DashboardCalendarEventsIdRouteRouteWithChildren
  DashboardCalendarEventsCreateRoute: typeof DashboardCalendarEventsCreateRoute
}

const DashboardCalendarEventsRouteRouteChildren: DashboardCalendarEventsRouteRouteChildren =
  {
    DashboardCalendarEventsIdRouteRoute:
      DashboardCalendarEventsIdRouteRouteWithChildren,
    DashboardCalendarEventsCreateRoute: DashboardCalendarEventsCreateRoute,
  }

const DashboardCalendarEventsRouteRouteWithChildren =
  DashboardCalendarEventsRouteRoute._addFileChildren(
    DashboardCalendarEventsRouteRouteChildren,
  )

interface DashboardCalendarRouteRouteChildren {
  DashboardCalendarEventsRouteRoute: typeof DashboardCalendarEventsRouteRouteWithChildren
  DashboardCalendarIndexRoute: typeof DashboardCalendarIndexRoute
}

const DashboardCalendarRouteRouteChildren: DashboardCalendarRouteRouteChildren =
  {
    DashboardCalendarEventsRouteRoute:
      DashboardCalendarEventsRouteRouteWithChildren,
    DashboardCalendarIndexRoute: DashboardCalendarIndexRoute,
  }

const DashboardCalendarRouteRouteWithChildren =
  DashboardCalendarRouteRoute._addFileChildren(
    DashboardCalendarRouteRouteChildren,
  )

interface DashboardCameraRouteRouteChildren {
  DashboardCameraIndexRoute: typeof DashboardCameraIndexRoute
}

const DashboardCameraRouteRouteChildren: DashboardCameraRouteRouteChildren = {
  DashboardCameraIndexRoute: DashboardCameraIndexRoute,
}

const DashboardCameraRouteRouteWithChildren =
  DashboardCameraRouteRoute._addFileChildren(DashboardCameraRouteRouteChildren)

interface DashboardCaseProgressNotesRouteRouteChildren {
  DashboardCaseProgressNotesClosedRoute: typeof DashboardCaseProgressNotesClosedRoute
  DashboardCaseProgressNotesIndexRoute: typeof DashboardCaseProgressNotesIndexRoute
}

const DashboardCaseProgressNotesRouteRouteChildren: DashboardCaseProgressNotesRouteRouteChildren =
  {
    DashboardCaseProgressNotesClosedRoute:
      DashboardCaseProgressNotesClosedRoute,
    DashboardCaseProgressNotesIndexRoute: DashboardCaseProgressNotesIndexRoute,
  }

const DashboardCaseProgressNotesRouteRouteWithChildren =
  DashboardCaseProgressNotesRouteRoute._addFileChildren(
    DashboardCaseProgressNotesRouteRouteChildren,
  )

interface DashboardCaseRecordsRouteRouteChildren {
  DashboardCaseRecordsClosedRoute: typeof DashboardCaseRecordsClosedRoute
  DashboardCaseRecordsIndexRoute: typeof DashboardCaseRecordsIndexRoute
}

const DashboardCaseRecordsRouteRouteChildren: DashboardCaseRecordsRouteRouteChildren =
  {
    DashboardCaseRecordsClosedRoute: DashboardCaseRecordsClosedRoute,
    DashboardCaseRecordsIndexRoute: DashboardCaseRecordsIndexRoute,
  }

const DashboardCaseRecordsRouteRouteWithChildren =
  DashboardCaseRecordsRouteRoute._addFileChildren(
    DashboardCaseRecordsRouteRouteChildren,
  )

interface DashboardCaseReferralsRouteRouteChildren {
  DashboardCaseReferralsContactRoute: typeof DashboardCaseReferralsContactRoute
  DashboardCaseReferralsMessageRoute: typeof DashboardCaseReferralsMessageRoute
  DashboardCaseReferralsSuccessRoute: typeof DashboardCaseReferralsSuccessRoute
  DashboardCaseReferralsTypeRoute: typeof DashboardCaseReferralsTypeRoute
  DashboardCaseReferralsIndexRoute: typeof DashboardCaseReferralsIndexRoute
}

const DashboardCaseReferralsRouteRouteChildren: DashboardCaseReferralsRouteRouteChildren =
  {
    DashboardCaseReferralsContactRoute: DashboardCaseReferralsContactRoute,
    DashboardCaseReferralsMessageRoute: DashboardCaseReferralsMessageRoute,
    DashboardCaseReferralsSuccessRoute: DashboardCaseReferralsSuccessRoute,
    DashboardCaseReferralsTypeRoute: DashboardCaseReferralsTypeRoute,
    DashboardCaseReferralsIndexRoute: DashboardCaseReferralsIndexRoute,
  }

const DashboardCaseReferralsRouteRouteWithChildren =
  DashboardCaseReferralsRouteRoute._addFileChildren(
    DashboardCaseReferralsRouteRouteChildren,
  )

interface DashboardCaseViewIdCaseInfoTypeRouteRouteChildren {
  DashboardCaseViewIdCaseInfoTypeIndexRoute: typeof DashboardCaseViewIdCaseInfoTypeIndexRoute
}

const DashboardCaseViewIdCaseInfoTypeRouteRouteChildren: DashboardCaseViewIdCaseInfoTypeRouteRouteChildren =
  {
    DashboardCaseViewIdCaseInfoTypeIndexRoute:
      DashboardCaseViewIdCaseInfoTypeIndexRoute,
  }

const DashboardCaseViewIdCaseInfoTypeRouteRouteWithChildren =
  DashboardCaseViewIdCaseInfoTypeRouteRoute._addFileChildren(
    DashboardCaseViewIdCaseInfoTypeRouteRouteChildren,
  )

interface DashboardCaseViewIdCaseInfoRouteRouteChildren {
  DashboardCaseViewIdCaseInfoTypeRouteRoute: typeof DashboardCaseViewIdCaseInfoTypeRouteRouteWithChildren
}

const DashboardCaseViewIdCaseInfoRouteRouteChildren: DashboardCaseViewIdCaseInfoRouteRouteChildren =
  {
    DashboardCaseViewIdCaseInfoTypeRouteRoute:
      DashboardCaseViewIdCaseInfoTypeRouteRouteWithChildren,
  }

const DashboardCaseViewIdCaseInfoRouteRouteWithChildren =
  DashboardCaseViewIdCaseInfoRouteRoute._addFileChildren(
    DashboardCaseViewIdCaseInfoRouteRouteChildren,
  )

interface DashboardCaseViewIdLetterLetterIdRouteRouteChildren {
  DashboardCaseViewIdLetterLetterIdExportRoute: typeof DashboardCaseViewIdLetterLetterIdExportRoute
  DashboardCaseViewIdLetterLetterIdUpdateRoute: typeof DashboardCaseViewIdLetterLetterIdUpdateRoute
  DashboardCaseViewIdLetterLetterIdIndexRoute: typeof DashboardCaseViewIdLetterLetterIdIndexRoute
}

const DashboardCaseViewIdLetterLetterIdRouteRouteChildren: DashboardCaseViewIdLetterLetterIdRouteRouteChildren =
  {
    DashboardCaseViewIdLetterLetterIdExportRoute:
      DashboardCaseViewIdLetterLetterIdExportRoute,
    DashboardCaseViewIdLetterLetterIdUpdateRoute:
      DashboardCaseViewIdLetterLetterIdUpdateRoute,
    DashboardCaseViewIdLetterLetterIdIndexRoute:
      DashboardCaseViewIdLetterLetterIdIndexRoute,
  }

const DashboardCaseViewIdLetterLetterIdRouteRouteWithChildren =
  DashboardCaseViewIdLetterLetterIdRouteRoute._addFileChildren(
    DashboardCaseViewIdLetterLetterIdRouteRouteChildren,
  )

interface DashboardCaseViewIdLetterNewRouteRouteChildren {
  DashboardCaseViewIdLetterNewInfoRoute: typeof DashboardCaseViewIdLetterNewInfoRoute
  DashboardCaseViewIdLetterNewIndexRoute: typeof DashboardCaseViewIdLetterNewIndexRoute
}

const DashboardCaseViewIdLetterNewRouteRouteChildren: DashboardCaseViewIdLetterNewRouteRouteChildren =
  {
    DashboardCaseViewIdLetterNewInfoRoute:
      DashboardCaseViewIdLetterNewInfoRoute,
    DashboardCaseViewIdLetterNewIndexRoute:
      DashboardCaseViewIdLetterNewIndexRoute,
  }

const DashboardCaseViewIdLetterNewRouteRouteWithChildren =
  DashboardCaseViewIdLetterNewRouteRoute._addFileChildren(
    DashboardCaseViewIdLetterNewRouteRouteChildren,
  )

interface DashboardCaseViewIdLetterRouteRouteChildren {
  DashboardCaseViewIdLetterLetterIdRouteRoute: typeof DashboardCaseViewIdLetterLetterIdRouteRouteWithChildren
  DashboardCaseViewIdLetterNewRouteRoute: typeof DashboardCaseViewIdLetterNewRouteRouteWithChildren
}

const DashboardCaseViewIdLetterRouteRouteChildren: DashboardCaseViewIdLetterRouteRouteChildren =
  {
    DashboardCaseViewIdLetterLetterIdRouteRoute:
      DashboardCaseViewIdLetterLetterIdRouteRouteWithChildren,
    DashboardCaseViewIdLetterNewRouteRoute:
      DashboardCaseViewIdLetterNewRouteRouteWithChildren,
  }

const DashboardCaseViewIdLetterRouteRouteWithChildren =
  DashboardCaseViewIdLetterRouteRoute._addFileChildren(
    DashboardCaseViewIdLetterRouteRouteChildren,
  )

interface DashboardCaseViewIdMembersRouteRouteChildren {
  DashboardCaseViewIdMembersExternalRoute: typeof DashboardCaseViewIdMembersExternalRoute
  DashboardCaseViewIdMembersIndexRoute: typeof DashboardCaseViewIdMembersIndexRoute
}

const DashboardCaseViewIdMembersRouteRouteChildren: DashboardCaseViewIdMembersRouteRouteChildren =
  {
    DashboardCaseViewIdMembersExternalRoute:
      DashboardCaseViewIdMembersExternalRoute,
    DashboardCaseViewIdMembersIndexRoute: DashboardCaseViewIdMembersIndexRoute,
  }

const DashboardCaseViewIdMembersRouteRouteWithChildren =
  DashboardCaseViewIdMembersRouteRoute._addFileChildren(
    DashboardCaseViewIdMembersRouteRouteChildren,
  )

interface DashboardCaseViewIdRouteRouteChildren {
  DashboardCaseViewIdCaseInfoRouteRoute: typeof DashboardCaseViewIdCaseInfoRouteRouteWithChildren
  DashboardCaseViewIdLetterRouteRoute: typeof DashboardCaseViewIdLetterRouteRouteWithChildren
  DashboardCaseViewIdMembersRouteRoute: typeof DashboardCaseViewIdMembersRouteRouteWithChildren
  DashboardCaseViewIdDetailRoute: typeof DashboardCaseViewIdDetailRoute
  DashboardCaseViewIdExportRoute: typeof DashboardCaseViewIdExportRoute
  DashboardCaseViewIdSearchRoute: typeof DashboardCaseViewIdSearchRoute
  DashboardCaseViewIdIndexRoute: typeof DashboardCaseViewIdIndexRoute
  DashboardCaseViewIdMedicalNoteCreateRoute: typeof DashboardCaseViewIdMedicalNoteCreateRoute
  DashboardCaseViewIdPatientVisitsCreateRoute: typeof DashboardCaseViewIdPatientVisitsCreateRoute
  DashboardCaseViewIdMedicalNoteIndexRoute: typeof DashboardCaseViewIdMedicalNoteIndexRoute
  DashboardCaseViewIdPatientVisitsIndexRoute: typeof DashboardCaseViewIdPatientVisitsIndexRoute
}

const DashboardCaseViewIdRouteRouteChildren: DashboardCaseViewIdRouteRouteChildren =
  {
    DashboardCaseViewIdCaseInfoRouteRoute:
      DashboardCaseViewIdCaseInfoRouteRouteWithChildren,
    DashboardCaseViewIdLetterRouteRoute:
      DashboardCaseViewIdLetterRouteRouteWithChildren,
    DashboardCaseViewIdMembersRouteRoute:
      DashboardCaseViewIdMembersRouteRouteWithChildren,
    DashboardCaseViewIdDetailRoute: DashboardCaseViewIdDetailRoute,
    DashboardCaseViewIdExportRoute: DashboardCaseViewIdExportRoute,
    DashboardCaseViewIdSearchRoute: DashboardCaseViewIdSearchRoute,
    DashboardCaseViewIdIndexRoute: DashboardCaseViewIdIndexRoute,
    DashboardCaseViewIdMedicalNoteCreateRoute:
      DashboardCaseViewIdMedicalNoteCreateRoute,
    DashboardCaseViewIdPatientVisitsCreateRoute:
      DashboardCaseViewIdPatientVisitsCreateRoute,
    DashboardCaseViewIdMedicalNoteIndexRoute:
      DashboardCaseViewIdMedicalNoteIndexRoute,
    DashboardCaseViewIdPatientVisitsIndexRoute:
      DashboardCaseViewIdPatientVisitsIndexRoute,
  }

const DashboardCaseViewIdRouteRouteWithChildren =
  DashboardCaseViewIdRouteRoute._addFileChildren(
    DashboardCaseViewIdRouteRouteChildren,
  )

interface DashboardCaseViewRouteRouteChildren {
  DashboardCaseViewIdRouteRoute: typeof DashboardCaseViewIdRouteRouteWithChildren
}

const DashboardCaseViewRouteRouteChildren: DashboardCaseViewRouteRouteChildren =
  {
    DashboardCaseViewIdRouteRoute: DashboardCaseViewIdRouteRouteWithChildren,
  }

const DashboardCaseViewRouteRouteWithChildren =
  DashboardCaseViewRouteRoute._addFileChildren(
    DashboardCaseViewRouteRouteChildren,
  )

interface DashboardCaseRouteRouteChildren {
  DashboardCaseProgressNotesRouteRoute: typeof DashboardCaseProgressNotesRouteRouteWithChildren
  DashboardCaseRecordsRouteRoute: typeof DashboardCaseRecordsRouteRouteWithChildren
  DashboardCaseReferralsRouteRoute: typeof DashboardCaseReferralsRouteRouteWithChildren
  DashboardCaseViewRouteRoute: typeof DashboardCaseViewRouteRouteWithChildren
  DashboardCaseStatusRoute: typeof DashboardCaseStatusRoute
  DashboardCaseIndexRoute: typeof DashboardCaseIndexRoute
  DashboardCaseMessageIdRoute: typeof DashboardCaseMessageIdRoute
  DashboardCaseCreateIndexRoute: typeof DashboardCaseCreateIndexRoute
  DashboardCasePatientIndexRoute: typeof DashboardCasePatientIndexRoute
  DashboardCaseCreateExistRequestCompleteRoute: typeof DashboardCaseCreateExistRequestCompleteRoute
  DashboardCaseCreateExistIndexRoute: typeof DashboardCaseCreateExistIndexRoute
  DashboardCaseCreateExistPatientPatientIcRoute: typeof DashboardCaseCreateExistPatientPatientIcRoute
  DashboardCaseCreateExistRequestCaseIdRoute: typeof DashboardCaseCreateExistRequestCaseIdRoute
}

const DashboardCaseRouteRouteChildren: DashboardCaseRouteRouteChildren = {
  DashboardCaseProgressNotesRouteRoute:
    DashboardCaseProgressNotesRouteRouteWithChildren,
  DashboardCaseRecordsRouteRoute: DashboardCaseRecordsRouteRouteWithChildren,
  DashboardCaseReferralsRouteRoute:
    DashboardCaseReferralsRouteRouteWithChildren,
  DashboardCaseViewRouteRoute: DashboardCaseViewRouteRouteWithChildren,
  DashboardCaseStatusRoute: DashboardCaseStatusRoute,
  DashboardCaseIndexRoute: DashboardCaseIndexRoute,
  DashboardCaseMessageIdRoute: DashboardCaseMessageIdRoute,
  DashboardCaseCreateIndexRoute: DashboardCaseCreateIndexRoute,
  DashboardCasePatientIndexRoute: DashboardCasePatientIndexRoute,
  DashboardCaseCreateExistRequestCompleteRoute:
    DashboardCaseCreateExistRequestCompleteRoute,
  DashboardCaseCreateExistIndexRoute: DashboardCaseCreateExistIndexRoute,
  DashboardCaseCreateExistPatientPatientIcRoute:
    DashboardCaseCreateExistPatientPatientIcRoute,
  DashboardCaseCreateExistRequestCaseIdRoute:
    DashboardCaseCreateExistRequestCaseIdRoute,
}

const DashboardCaseRouteRouteWithChildren =
  DashboardCaseRouteRoute._addFileChildren(DashboardCaseRouteRouteChildren)

interface DashboardChatGroupIdRouteRouteChildren {
  DashboardChatGroupIdChannelNameRoute: typeof DashboardChatGroupIdChannelNameRoute
  DashboardChatGroupIdDetailRoute: typeof DashboardChatGroupIdDetailRoute
  DashboardChatGroupIdEditRoute: typeof DashboardChatGroupIdEditRoute
  DashboardChatGroupIdMembersRoute: typeof DashboardChatGroupIdMembersRoute
  DashboardChatGroupIdIndexRoute: typeof DashboardChatGroupIdIndexRoute
}

const DashboardChatGroupIdRouteRouteChildren: DashboardChatGroupIdRouteRouteChildren =
  {
    DashboardChatGroupIdChannelNameRoute: DashboardChatGroupIdChannelNameRoute,
    DashboardChatGroupIdDetailRoute: DashboardChatGroupIdDetailRoute,
    DashboardChatGroupIdEditRoute: DashboardChatGroupIdEditRoute,
    DashboardChatGroupIdMembersRoute: DashboardChatGroupIdMembersRoute,
    DashboardChatGroupIdIndexRoute: DashboardChatGroupIdIndexRoute,
  }

const DashboardChatGroupIdRouteRouteWithChildren =
  DashboardChatGroupIdRouteRoute._addFileChildren(
    DashboardChatGroupIdRouteRouteChildren,
  )

interface DashboardChatSingleIdRouteRouteChildren {
  DashboardChatSingleIdChannelNameRoute: typeof DashboardChatSingleIdChannelNameRoute
}

const DashboardChatSingleIdRouteRouteChildren: DashboardChatSingleIdRouteRouteChildren =
  {
    DashboardChatSingleIdChannelNameRoute:
      DashboardChatSingleIdChannelNameRoute,
  }

const DashboardChatSingleIdRouteRouteWithChildren =
  DashboardChatSingleIdRouteRoute._addFileChildren(
    DashboardChatSingleIdRouteRouteChildren,
  )

interface DashboardChatSingleHemiRouteRouteChildren {
  DashboardChatSingleHemiIndexRoute: typeof DashboardChatSingleHemiIndexRoute
}

const DashboardChatSingleHemiRouteRouteChildren: DashboardChatSingleHemiRouteRouteChildren =
  {
    DashboardChatSingleHemiIndexRoute: DashboardChatSingleHemiIndexRoute,
  }

const DashboardChatSingleHemiRouteRouteWithChildren =
  DashboardChatSingleHemiRouteRoute._addFileChildren(
    DashboardChatSingleHemiRouteRouteChildren,
  )

interface DashboardChatRouteRouteChildren {
  DashboardChatGroupIdRouteRoute: typeof DashboardChatGroupIdRouteRouteWithChildren
  DashboardChatSingleIdRouteRoute: typeof DashboardChatSingleIdRouteRouteWithChildren
  DashboardChatSingleHemiRouteRoute: typeof DashboardChatSingleHemiRouteRouteWithChildren
  DashboardChatGroupCreateRoute: typeof DashboardChatGroupCreateRoute
  DashboardChatMessageIdRoute: typeof DashboardChatMessageIdRoute
  DashboardChatSingleCreateRoute: typeof DashboardChatSingleCreateRoute
  DashboardChatGroupIndexRoute: typeof DashboardChatGroupIndexRoute
  DashboardChatSingleIndexRoute: typeof DashboardChatSingleIndexRoute
}

const DashboardChatRouteRouteChildren: DashboardChatRouteRouteChildren = {
  DashboardChatGroupIdRouteRoute: DashboardChatGroupIdRouteRouteWithChildren,
  DashboardChatSingleIdRouteRoute: DashboardChatSingleIdRouteRouteWithChildren,
  DashboardChatSingleHemiRouteRoute:
    DashboardChatSingleHemiRouteRouteWithChildren,
  DashboardChatGroupCreateRoute: DashboardChatGroupCreateRoute,
  DashboardChatMessageIdRoute: DashboardChatMessageIdRoute,
  DashboardChatSingleCreateRoute: DashboardChatSingleCreateRoute,
  DashboardChatGroupIndexRoute: DashboardChatGroupIndexRoute,
  DashboardChatSingleIndexRoute: DashboardChatSingleIndexRoute,
}

const DashboardChatRouteRouteWithChildren =
  DashboardChatRouteRoute._addFileChildren(DashboardChatRouteRouteChildren)

interface DashboardContactsRouteRouteChildren {
  DashboardContactsNoAccessRoute: typeof DashboardContactsNoAccessRoute
  DashboardContactsIndexRoute: typeof DashboardContactsIndexRoute
  DashboardContactsMemberIdRoute: typeof DashboardContactsMemberIdRoute
  DashboardContactsContactIndexRoute: typeof DashboardContactsContactIndexRoute
  DashboardContactsDirectoryIndexRoute: typeof DashboardContactsDirectoryIndexRoute
  DashboardContactsContactTeamsIndexRoute: typeof DashboardContactsContactTeamsIndexRoute
  DashboardContactsDirectoryTeamsIndexRoute: typeof DashboardContactsDirectoryTeamsIndexRoute
}

const DashboardContactsRouteRouteChildren: DashboardContactsRouteRouteChildren =
  {
    DashboardContactsNoAccessRoute: DashboardContactsNoAccessRoute,
    DashboardContactsIndexRoute: DashboardContactsIndexRoute,
    DashboardContactsMemberIdRoute: DashboardContactsMemberIdRoute,
    DashboardContactsContactIndexRoute: DashboardContactsContactIndexRoute,
    DashboardContactsDirectoryIndexRoute: DashboardContactsDirectoryIndexRoute,
    DashboardContactsContactTeamsIndexRoute:
      DashboardContactsContactTeamsIndexRoute,
    DashboardContactsDirectoryTeamsIndexRoute:
      DashboardContactsDirectoryTeamsIndexRoute,
  }

const DashboardContactsRouteRouteWithChildren =
  DashboardContactsRouteRoute._addFileChildren(
    DashboardContactsRouteRouteChildren,
  )

interface DashboardInboxAlertsRouteRouteChildren {
  DashboardInboxAlertsIndexRoute: typeof DashboardInboxAlertsIndexRoute
}

const DashboardInboxAlertsRouteRouteChildren: DashboardInboxAlertsRouteRouteChildren =
  {
    DashboardInboxAlertsIndexRoute: DashboardInboxAlertsIndexRoute,
  }

const DashboardInboxAlertsRouteRouteWithChildren =
  DashboardInboxAlertsRouteRoute._addFileChildren(
    DashboardInboxAlertsRouteRouteChildren,
  )

interface DashboardInboxRemindersRouteRouteChildren {
  DashboardInboxRemindersIdRoute: typeof DashboardInboxRemindersIdRoute
  DashboardInboxRemindersCompletedRoute: typeof DashboardInboxRemindersCompletedRoute
  DashboardInboxRemindersCreateRoute: typeof DashboardInboxRemindersCreateRoute
  DashboardInboxRemindersIndexRoute: typeof DashboardInboxRemindersIndexRoute
}

const DashboardInboxRemindersRouteRouteChildren: DashboardInboxRemindersRouteRouteChildren =
  {
    DashboardInboxRemindersIdRoute: DashboardInboxRemindersIdRoute,
    DashboardInboxRemindersCompletedRoute:
      DashboardInboxRemindersCompletedRoute,
    DashboardInboxRemindersCreateRoute: DashboardInboxRemindersCreateRoute,
    DashboardInboxRemindersIndexRoute: DashboardInboxRemindersIndexRoute,
  }

const DashboardInboxRemindersRouteRouteWithChildren =
  DashboardInboxRemindersRouteRoute._addFileChildren(
    DashboardInboxRemindersRouteRouteChildren,
  )

interface DashboardInboxRouteRouteChildren {
  DashboardInboxAlertsRouteRoute: typeof DashboardInboxAlertsRouteRouteWithChildren
  DashboardInboxRemindersRouteRoute: typeof DashboardInboxRemindersRouteRouteWithChildren
  DashboardInboxIndexRoute: typeof DashboardInboxIndexRoute
}

const DashboardInboxRouteRouteChildren: DashboardInboxRouteRouteChildren = {
  DashboardInboxAlertsRouteRoute: DashboardInboxAlertsRouteRouteWithChildren,
  DashboardInboxRemindersRouteRoute:
    DashboardInboxRemindersRouteRouteWithChildren,
  DashboardInboxIndexRoute: DashboardInboxIndexRoute,
}

const DashboardInboxRouteRouteWithChildren =
  DashboardInboxRouteRoute._addFileChildren(DashboardInboxRouteRouteChildren)

interface DashboardTeamsIdEditRouteRouteChildren {
  DashboardTeamsIdEditMembersRoute: typeof DashboardTeamsIdEditMembersRoute
  DashboardTeamsIdEditIndexRoute: typeof DashboardTeamsIdEditIndexRoute
}

const DashboardTeamsIdEditRouteRouteChildren: DashboardTeamsIdEditRouteRouteChildren =
  {
    DashboardTeamsIdEditMembersRoute: DashboardTeamsIdEditMembersRoute,
    DashboardTeamsIdEditIndexRoute: DashboardTeamsIdEditIndexRoute,
  }

const DashboardTeamsIdEditRouteRouteWithChildren =
  DashboardTeamsIdEditRouteRoute._addFileChildren(
    DashboardTeamsIdEditRouteRouteChildren,
  )

interface DashboardTeamsIdMembersRouteRouteChildren {
  DashboardTeamsIdMembersSearchRoute: typeof DashboardTeamsIdMembersSearchRoute
}

const DashboardTeamsIdMembersRouteRouteChildren: DashboardTeamsIdMembersRouteRouteChildren =
  {
    DashboardTeamsIdMembersSearchRoute: DashboardTeamsIdMembersSearchRoute,
  }

const DashboardTeamsIdMembersRouteRouteWithChildren =
  DashboardTeamsIdMembersRouteRoute._addFileChildren(
    DashboardTeamsIdMembersRouteRouteChildren,
  )

interface DashboardTeamsIdRouteRouteChildren {
  DashboardTeamsIdEditRouteRoute: typeof DashboardTeamsIdEditRouteRouteWithChildren
  DashboardTeamsIdMembersRouteRoute: typeof DashboardTeamsIdMembersRouteRouteWithChildren
  DashboardTeamsIdIndexRoute: typeof DashboardTeamsIdIndexRoute
}

const DashboardTeamsIdRouteRouteChildren: DashboardTeamsIdRouteRouteChildren = {
  DashboardTeamsIdEditRouteRoute: DashboardTeamsIdEditRouteRouteWithChildren,
  DashboardTeamsIdMembersRouteRoute:
    DashboardTeamsIdMembersRouteRouteWithChildren,
  DashboardTeamsIdIndexRoute: DashboardTeamsIdIndexRoute,
}

const DashboardTeamsIdRouteRouteWithChildren =
  DashboardTeamsIdRouteRoute._addFileChildren(
    DashboardTeamsIdRouteRouteChildren,
  )

interface DashboardTeamsCreateRouteRouteChildren {
  DashboardTeamsCreateNameRoute: typeof DashboardTeamsCreateNameRoute
  DashboardTeamsCreateIndexRoute: typeof DashboardTeamsCreateIndexRoute
}

const DashboardTeamsCreateRouteRouteChildren: DashboardTeamsCreateRouteRouteChildren =
  {
    DashboardTeamsCreateNameRoute: DashboardTeamsCreateNameRoute,
    DashboardTeamsCreateIndexRoute: DashboardTeamsCreateIndexRoute,
  }

const DashboardTeamsCreateRouteRouteWithChildren =
  DashboardTeamsCreateRouteRoute._addFileChildren(
    DashboardTeamsCreateRouteRouteChildren,
  )

interface DashboardTeamsRouteRouteChildren {
  DashboardTeamsIdRouteRoute: typeof DashboardTeamsIdRouteRouteWithChildren
  DashboardTeamsCreateRouteRoute: typeof DashboardTeamsCreateRouteRouteWithChildren
}

const DashboardTeamsRouteRouteChildren: DashboardTeamsRouteRouteChildren = {
  DashboardTeamsIdRouteRoute: DashboardTeamsIdRouteRouteWithChildren,
  DashboardTeamsCreateRouteRoute: DashboardTeamsCreateRouteRouteWithChildren,
}

const DashboardTeamsRouteRouteWithChildren =
  DashboardTeamsRouteRoute._addFileChildren(DashboardTeamsRouteRouteChildren)

interface DashboardGalleryViewRouteRouteChildren {
  DashboardGalleryViewIdRoute: typeof DashboardGalleryViewIdRoute
}

const DashboardGalleryViewRouteRouteChildren: DashboardGalleryViewRouteRouteChildren =
  {
    DashboardGalleryViewIdRoute: DashboardGalleryViewIdRoute,
  }

const DashboardGalleryViewRouteRouteWithChildren =
  DashboardGalleryViewRouteRoute._addFileChildren(
    DashboardGalleryViewRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardBulletinRouteRoute: typeof DashboardBulletinRouteRouteWithChildren
  DashboardCalendarRouteRoute: typeof DashboardCalendarRouteRouteWithChildren
  DashboardCameraRouteRoute: typeof DashboardCameraRouteRouteWithChildren
  DashboardCaseRouteRoute: typeof DashboardCaseRouteRouteWithChildren
  DashboardChatRouteRoute: typeof DashboardChatRouteRouteWithChildren
  DashboardContactsRouteRoute: typeof DashboardContactsRouteRouteWithChildren
  DashboardInboxRouteRoute: typeof DashboardInboxRouteRouteWithChildren
  DashboardTeamsRouteRoute: typeof DashboardTeamsRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardGalleryViewRouteRoute: typeof DashboardGalleryViewRouteRouteWithChildren
  DashboardGalleryCameraRoute: typeof DashboardGalleryCameraRoute
  DashboardGalleryExportsRoute: typeof DashboardGalleryExportsRoute
  DashboardGalleryVideoRoute: typeof DashboardGalleryVideoRoute
  DashboardAccountsIndexRoute: typeof DashboardAccountsIndexRoute
  DashboardGalleryIndexRoute: typeof DashboardGalleryIndexRoute
  DashboardAccountsSettingsAccountChangeEmailRoute: typeof DashboardAccountsSettingsAccountChangeEmailRoute
  DashboardAccountsSettingsAccountChangePasswordRoute: typeof DashboardAccountsSettingsAccountChangePasswordRoute
  DashboardAccountsSettingsAccountChangePhoneNumberRoute: typeof DashboardAccountsSettingsAccountChangePhoneNumberRoute
  DashboardAccountsSettingsAccountDeleteAccountRoute: typeof DashboardAccountsSettingsAccountDeleteAccountRoute
  DashboardAccountsSettingsAccountNewPasswordRoute: typeof DashboardAccountsSettingsAccountNewPasswordRoute
  DashboardAccountsSettingsAccountVerifyPhoneNumberRoute: typeof DashboardAccountsSettingsAccountVerifyPhoneNumberRoute
  DashboardAccountsSettingsProfileCredentialsRoute: typeof DashboardAccountsSettingsProfileCredentialsRoute
  DashboardAccountsSettingsProfileInformationRoute: typeof DashboardAccountsSettingsProfileInformationRoute
  DashboardAccountsSettingsAccountIndexRoute: typeof DashboardAccountsSettingsAccountIndexRoute
  DashboardAccountsSettingsProfileIndexRoute: typeof DashboardAccountsSettingsProfileIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardBulletinRouteRoute: DashboardBulletinRouteRouteWithChildren,
  DashboardCalendarRouteRoute: DashboardCalendarRouteRouteWithChildren,
  DashboardCameraRouteRoute: DashboardCameraRouteRouteWithChildren,
  DashboardCaseRouteRoute: DashboardCaseRouteRouteWithChildren,
  DashboardChatRouteRoute: DashboardChatRouteRouteWithChildren,
  DashboardContactsRouteRoute: DashboardContactsRouteRouteWithChildren,
  DashboardInboxRouteRoute: DashboardInboxRouteRouteWithChildren,
  DashboardTeamsRouteRoute: DashboardTeamsRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardGalleryViewRouteRoute: DashboardGalleryViewRouteRouteWithChildren,
  DashboardGalleryCameraRoute: DashboardGalleryCameraRoute,
  DashboardGalleryExportsRoute: DashboardGalleryExportsRoute,
  DashboardGalleryVideoRoute: DashboardGalleryVideoRoute,
  DashboardAccountsIndexRoute: DashboardAccountsIndexRoute,
  DashboardGalleryIndexRoute: DashboardGalleryIndexRoute,
  DashboardAccountsSettingsAccountChangeEmailRoute:
    DashboardAccountsSettingsAccountChangeEmailRoute,
  DashboardAccountsSettingsAccountChangePasswordRoute:
    DashboardAccountsSettingsAccountChangePasswordRoute,
  DashboardAccountsSettingsAccountChangePhoneNumberRoute:
    DashboardAccountsSettingsAccountChangePhoneNumberRoute,
  DashboardAccountsSettingsAccountDeleteAccountRoute:
    DashboardAccountsSettingsAccountDeleteAccountRoute,
  DashboardAccountsSettingsAccountNewPasswordRoute:
    DashboardAccountsSettingsAccountNewPasswordRoute,
  DashboardAccountsSettingsAccountVerifyPhoneNumberRoute:
    DashboardAccountsSettingsAccountVerifyPhoneNumberRoute,
  DashboardAccountsSettingsProfileCredentialsRoute:
    DashboardAccountsSettingsProfileCredentialsRoute,
  DashboardAccountsSettingsProfileInformationRoute:
    DashboardAccountsSettingsProfileInformationRoute,
  DashboardAccountsSettingsAccountIndexRoute:
    DashboardAccountsSettingsAccountIndexRoute,
  DashboardAccountsSettingsProfileIndexRoute:
    DashboardAccountsSettingsProfileIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface SsoRouteRouteChildren {
  SsoSelectProviderRoute: typeof SsoSelectProviderRoute
  SsoSigninRoute: typeof SsoSigninRoute
}

const SsoRouteRouteChildren: SsoRouteRouteChildren = {
  SsoSelectProviderRoute: SsoSelectProviderRoute,
  SsoSigninRoute: SsoSigninRoute,
}

const SsoRouteRouteWithChildren = SsoRouteRoute._addFileChildren(
  SsoRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CreateAccountRouteRoute: CreateAccountRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  SsoRouteRoute: SsoRouteRouteWithChildren,
  AccountRoute: AccountRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  DeleteAccountSuccessRoute: DeleteAccountSuccessRoute,
  DownloadRoute: DownloadRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ManageSubscriptionRoute: ManageSubscriptionRoute,
  NewPasswordRoute: NewPasswordRoute,
  PatientPolicyRoute: PatientPolicyRoute,
  PaymentFailedRoute: PaymentFailedRoute,
  PaymentSuccessRoute: PaymentSuccessRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SubscriptionRequiredRoute: SubscriptionRequiredRoute,
  SuccessRoute: SuccessRoute,
  TermServiceRoute: TermServiceRoute,
  VerificationRoute: VerificationRoute,
  SubscriptionPlanRoute: SubscriptionPlanRoute,
  SubscriptionIndexRoute: SubscriptionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
